import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui'
import {Base64} from 'js-base64';
import MD5 from 'js-md5';
import crypto from 'crypto';
// import {getQuery2object} from './utils'

let eventSort = 0;
let examType = null;   // 2考试  3 || 7综合  4单项  5测验  6大赛  15课证融通测评

// 平台跳转
async function plateformJump(obj, sort, mechanisms,roleCode) {

  if(obj.listItem && obj.listItem.model === 'cy'){  // 考试 分两种
    if(Number(obj.productFlag) === 1){  // 课政融通
      examType = 15   // 课政融通测评
    }else{
      examType = 5  // 测验考试
    }
  }else if(Number(obj.productFlag) === 1 || Number(obj.productFlag) === 2){  // 课政融通
    examType = 4
  }else if(Number(obj.productFlag) === 3 || Number(obj.productFlag) === 7){  //综合实训
    examType = 3
  }

  // 添加roleCode 实训2.0多角色进入系统
  console.log('plateformJump ===== ', obj, sort, mechanisms,roleCode, examType)

  if (sort) eventSort = sort;
  let JumpReturnParams = {}
  // 赛段三拆分后的platform集合
  // let szjrArr = [
  //   'CloudFinance','BigDataFinance','BlockchainFinance','ZcSecuritization','HangkongInsurance','BlockchainInvoice',
  //   'NongcpSupplychain','BlockchainAudit','DigitalPayment','CrossborderFinance','DigitalBank','BigwealthManagement',
  //   'DigitalSecurity','DigitalInsurance','FinanceTechNew','FinancialRegulation','PersonPictureOS','BlockCrossborderFinance','FinanceManageAccount'
  // ]
  let szjrArr = [
    'CloudFinance','BigDataFinance','BlockchainAudit','DigitalPayment','CrossborderFinance','DigitalBank','BigwealthManagement',
    'DigitalSecurity','DigitalInsurance','FinanceTechNew','FinancialRegulation','PersonPictureOS','BlockCrossborderFinance','FinanceManageAccount','SupplyChainFinanceOS2024'
  ]
  let tage3Arr = [
    'BlockchainFinance','ZcSecuritization','HangkongInsurance','BlockchainInvoice', 'NongcpSupplychain',
  ]
  // 代码填空跳转platform集合
  let codeFangZhenArr = [
    'CodeFangZhenPage','Firewall','NetworkSecurity','LobbyManagerFangZhenVr',
  ]
  // 业财一体化platform集合
  let ycythArr = [
    'budget', 'basicdata','imagecenter','reimburse','settlement','journal','bill','asset','salary','archives','cashier','cost',
    'purchase','sale','inventory','tax','travel','ToJss','ToTax', 'dataAsset'
  ]

  /**
   *  mechanisms 跳转机制  目前是两种 三天下RPA 和 常用跳转
   **/
  if ((obj.platform === 'ctx' || obj.platform === 'ptx' || obj.platform === 'jss' || obj.platform === 'gxl') && mechanisms === 'RPAOS') { //(RPA跳转)三天下
    await stxRpaJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if ((obj.platform === 'ctx' || obj.platform === 'ptx' || obj.platform === 'jss' || obj.platform === 'gxl' || obj.platform === 'jssDx') && !mechanisms) { //三天下 //供应链
    // 单项中的财天下jssDx跳转  wdd 2023.8.3
    await stxJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'zhcx' || obj.platform === 'zcgl' || obj.platform === 'zygl' || obj.platform === 'zjbz' || obj.platform === 'kjhs') { //三资
    await sanziJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'mgy') { //摩估云
    await mgyJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'middleMGY') { //摩估云-中级
    await middleMGYJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'gzyy') { //摩估云-估值应用
    await gzyyJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'dummy') { //政务仿真
    await zwfzJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'shanglv') { //商旅
    await shanglvJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'auditExcel') { //审计
    await sjJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'ECommerce') { //电商实训
    await dsJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'dummyPro') { //电商仿真
    await dsfzJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'BusinessAnalyticsOS') { //商务数据分析
    await swsjfxJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'DigitalFinanceOS') { //数字金融业务系统
    await szjrywJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (szjrArr.includes(obj.platform)) { //赛段三
    await JR3_Jump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (tage3Arr.includes(obj.platform)) { //赛段三单独jxl
    await tage3_Jump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'blockjrkj') { //区块链-供应链金融
                                             // } else if (obj.platform === 'blockjrkj' || obj.platform === 'blockjrkjds') { //区块链-供应链金融
    await blockjrkjJump(obj).then((data) => {
      JumpReturnParams = data
    })
    // } else if (obj.platform === 'blockjrkjsx') { //区块链-供应链金融
    //   await blockjrkjsxJump(obj).then((data) => {
    //     JumpReturnParams = data
    //   })
  } else if (obj.platform === 'gxzxszzq') { //新证券业务数字化
    await gxzxszzqJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'LobbyManagerOS') { //数字金融赛段二-柜台业务
    await gtywJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'PCLiveOS') { //pc直播
    await pcliveJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'JiXiaoOS') { //绩效管理
    await JiXiaoOSJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'FinanceManageAccount') { //新绩效管理-智慧金融
    await FinanceManageAccountJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'ExcelOS' || obj.platform === 'ExcelOS_Bak') { //答题板
    await ExcelOSJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'BigDataOS') { //大数据
    await BigDataOSJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'ZLBigDataOS') { //zl大数据
    await ZLBigDataOSJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'ZLBigData2.0') { //zl大数据2.0
    await zlbdJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform.includes('managementAccount') || obj.platform.includes('finance')) { //管理会计
    await glkjJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'FZBAOSHUI') { //仿真报税
    await FZBSJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'ChinaGovTaxApply') {
    // (税务仿真平台)  自然人电子税务局（扣缴端） 跳转
    // wjl 2022.5.9
    await ZRRDZSWJJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'ChinaGovTaxApply2.0') {
    // 个税跳转--仅供测试使用
    // zjf 2023.7.12
    await ZRRDZSWJ2Jump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'BlockChainOS') {
    // 区块链平台建设
    // wjl 2022.6.23
    await qklJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'shenliBaoGaoOsprer') {
    // 审计数据
    // sq 2023.6.25
    await sjsjJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (codeFangZhenArr.includes(obj.platform)) {
    // platform=Firewall  仿真防火墙虚拟平台-安全设备部署与配置
    // platform=NetworkSecurity  IT管理--仿真网络安全模拟器
    // platform=CodeFangZhenPage   IT管理-仿真代码填空题模板
    // LobbyManagerFangZhenVr 大堂经理-vr
    // wjl 2022.6.23
    await codeFangZhenPageJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (ycythArr.includes(obj.platform)) {
    /*
     * basicdata("basicdata","运营中心"),
     * budget("budget","数字管理会计"),
     * dataAsset("dataAsset","数据资产"),
     * imagecenter("imagecenter","影像中心"),
     * reimburse("reimburse","报账中心"),
     * settlement("settlement","结算中心"),
     * journal("journal","会计核算"),
     * bill("bill","票据管理"),
     * asset("asset","资产管理"),
     * salary("salary","薪资管理"),
     * archives("archives","档案中心"),
     * cashier("cashier","出纳中心"),
     * cost("cost","成本中心"),
     *
     *  author: wjl
     */

    /*
     *   purchase("purchase","采购管理"),
     *   sale("sale","销售管理"),
     *   inventory("inventory","库存管理"),
     *   travel("travel","商旅费控"),"差旅费控"
     *   tax("tax","金税师"),
     *   ToJss("ToJss","金税师"),
     *   ToTax("ToTax","金税师"),
     *   author: wjl
     */

    await ycythJump(obj,roleCode).then((data) => {
      JumpReturnParams = data
    })

  } else if ( obj.platform ===  'sqlDataOS') {
    await sqlDataOSJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if ( obj.platform ===  'WuLiuFangZhenVr') { // 物流vr
    await wuliuJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'wpsOS') { //智能文档
    await officeJump(obj).then((data) => {
      JumpReturnParams = data
    })
  } else if (obj.platform === 'ECommercePro') { // 惦尚
    await ECommerceProJump(obj).then((data) => {
      JumpReturnParams = data
    })
  }
  else {
    // 不认识的内容
    Message({
      message: obj.platform + '-访问无效',
      type: 'error',
      showClose: true
    })
  }
  return JumpReturnParams
}

/* 业财一体化 */
async function ycythJump(obj,roleCode){
  let iframeUrl = '';
  if(roleCode){
    obj.paramsList.forEach((item)=>{
      if(item.key=='roles' ){
        item.value =roleCode
      }
    })
  }

  let param = await zljtLoginParams(obj, obj.platform).then(res => {
    return res
  })
  sessionStorage.setItem('rpaParams',JSON.stringify(param))
  let params = {
    "clientId": param.clientId,
    "encrypted": param.encrypted,
    "identity": obj.platform,
    "item": param.item,
    "qstId": param.qstId,
    "roleCode": roleCode?roleCode:param.roleCode,
    "sign": param.sign,
    "templateCode": param.templateCode,
    "timeStamp": param.timeStamp,
    "token": param.token,
    "userType": param.userType,
    "username": param.username,
    "openId": param.userId,
    "nickname": obj.nickname,
    "schoolId": obj.deptId,
    "schoolName": obj.deptName,
    "className": obj.className,
    "classId": obj.classId,
    "teamName": obj.teamName,
    "teamId": obj.teamId,
    "examPlan": '',
    "examType": examType,  // 2考试  3综合  4单项  5测验  6大赛  15课证融通测评
    "courseId": obj.courseId,
    "paperCode": '',
  }
  if(examType === 15){
    params['userCode'] = param.userId
  }

  if (param.examType == '4' || (param.examType == '3' || param.examType == '15') && param.templateCode !== 'default'){//单项、综合实训templateCode!=='default'
    if(obj.platform === 'budget'){
      params['module'] = 'performance,strategic,budget,operation,investformulate,costControl'
    }else{
      params['module'] = 'asset,purchase,settlement,reimburse,imagecenter,basicdata,sale,salary,inventory,journal,tax,dataAsset'
    }
    params['lightInit'] = 2
  }

  /* 调用业财一体化tokenApi,获取业财一体化业务系统token */
  await axios.post(`${ getEnv('VUE_APP_VTAXTAPI') }/api-oauth/v1/oauth/v2/oauth/token`, params).then(res => {
    if (res.data.code == 0) {
      sessionStorage.setItem('zljtToken',res.data.data.access_token)
      params = {
        token: res.data.data.access_token,
        identity: obj.platform, // 正确的
        sourceId: param.encrypted,
        roleCode: roleCode?roleCode:param.roleCode,
      }

      let jumpUrl = '';

      if (
        obj.platform === 'basicdata'
        || obj.platform === 'imagecenter'
        || obj.platform === 'reimburse'
        || obj.platform === 'settlement'
        || obj.platform === 'journal'
        || obj.platform === 'bill'
        || obj.platform === 'asset'
        || obj.platform === 'salary'
        || obj.platform === 'archives'
        || obj.platform === 'cashier'
        || obj.platform === 'cost'
      ){
        /** basicdata("basicdata","运营中心"),
         *  imagecenter("imagecenter","影像中心"),
         *  reimburse("reimburse","报账中心"),
         *  settlement("settlement","结算中心"),
         *  journal("journal","会计核算"),
         *  bill("bill","票据管理"),
         *  asset("asset","资产管理"),
         *  salary("salary","薪资管理"),
         *  archives("archives","档案中心"),
         *  cashier("cashier","出纳中心"),
         *  cost("cost","成本中心"),
         */
        jumpUrl = getEnv('VUE_APP_YCYTH')
      }else if(obj.platform === 'purchase' || obj.platform === 'sale' || obj.platform === 'inventory'){
        /* 供应链系统 */
        /**
         *  purchase("purchase","采购管理"),
         *  sale("sale","销售管理"),
         *  inventory("inventory","库存管理"),
         */
        jumpUrl = getEnv('VUE_APP_SUPPLY')
      }else if(obj.platform === 'tax' || obj.platform === 'ToJss' || obj.platform === 'ToTax'){
        /**
         *  tax("tax","金税师"),
         *  ToJss("ToJss","金税师"),
         *  ToTax("ToTax","金税师"),
         */
        jumpUrl = getEnv('VUE_APP_VTAXT')
      }else if(obj.platform === 'travel'){
        /* "travel","商旅" */
        jumpUrl = getEnv('VUE_APP_TRAVEL')
      }else if(obj.platform === 'dataAsset') { // 数据资产
        /* "数据资产" */
        jumpUrl = getEnv('VUE_APP_ASSET')

        params['qstId'] = obj.listItem.id;
        params['examType'] = examType;
      }else if(obj.platform === 'budget'){
        /*  budget("budget","数字管理会计") */
        jumpUrl = getEnv('VUE_APP_BUDGET')
      }

      let src = `${jumpUrl}/#/login-sso?${qs.stringify(params)}`
      iframeUrl = src
      console.log('-跳转业财一体化： ',iframeUrl)
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })

  return {...param, iframeUrl}
}

// async function newJump(newObj) {
//
//   let iframeUrl = '';
//   let hostApi = newObj.beforePlatform.urlPath;
//   // 获取所需参数
//   let param = await zljtLoginParams(newObj, newObj.platform).then(res => {
//     return res
//   })
//
//   // 综合实训
//   if (newObj.productFlag === '3') {
//     let params = {
//       "clientId": param.clientId,
//       "encrypted": param.encrypted,
//       "identity": newObj.platform,
//       "item": param.item,
//       "qstId": param.qstId,
//       "roleCode": param.roleCode,
//       "sign": param.sign,
//       "templateCode": param.templateCode,
//       "timeStamp": param.timeStamp,
//       "token": param.token,
//       "userType": param.userType,
//       "username": param.username,
//       "openId": param.userId,
//       "nickname": newObj.nickname,
//       "schoolId": newObj.deptId,
//       "schoolName": newObj.deptName,
//       "classId": newObj.classId,
//       "teamId": newObj.teamId,
//       "examPlan": '',
//       "examType": 3,  // 2考试  3综合  4单项  5测验  6大赛  15课证融通测评
//       "courseId": newObj.courseId,
//       "paperCode": '',
//     }
//
//     // 新的获取token  api
//     await axios.post(hostApi, params).then(res => {
//       if (res.data.data) {
//         iframeUrl = res.data.data;
//       } else {
//         Message({
//           message: res.data.msg,
//           type: 'error',
//           showClose: true
//         })
//       }
//     }).catch(err => {
//       console.log(err)
//     })
//   }
//   return {...param, iframeUrl}
// }

// 三天下跳转
async function stxJump(obj) {

  let iframeUrl = ''
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let catalogType = obj.catalogType || 'NONE'
  let teamId = 'NONE'
  let teamName = ''
  let roles = ''
  if (obj.myStation && obj.myStation[0]) {
    if (obj.myStation[0].teamId) {
      teamId = obj.myStation[0].teamId
    }
    teamName = obj.myStation[0].teamName
    roles = obj.myStation.map(item => item.code).join()
  }

  if (obj.productFlag === '1' || obj.productFlag === '2') { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag === '3' || obj.productFlag === '7') {  //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }

  let {
    paramsList
  } = obj;
  let host = "";
  let arr = [];
  let templateCode = ""
  if (obj.productFlag == '1' || obj.productFlag == '2') { //单项
    let roleCode = ""
    if (paramsList.length > 0) {
      paramsList.forEach(v => {
        if (v.key === "templateCode") {
          templateCode = v.value
        }
        if (v.key === "roles") {
          roleCode = v.value
        }
      })
    }
    let model = ""
    if (obj.listItem.model) {
      model = obj.listItem.model
    } else {
      model = 'zx'
    }
    arr = [
      { key: "classId", value: obj.classId },
      { key: "className", value: obj.className },
      { key: "courseId", value: obj.courseId },
      { key: "mobile", value: obj.mobile },
      { key: "model", value: model },
      { key: "nickName", value: obj.nickname },
      { key: "platform", value: obj.platform == 'kjhs' ? 'ctx' : obj.platform },
      { key: "questionId", value: obj.listItem.id },
      { key: "roles", value: roleCode },
      { key: "schoolId", value: obj.deptId },
      { key: "schoolName", value: obj.deptName },
      { key: "templateCode", value: templateCode },
      { key: "time", value: obj.timestamp },
      { key: "userId", value: obj.userId },
    ];
    if (model == 'cy') {
      arr.push({
        key: "paperId",
        value: obj.listItem.paperId
      })
    }
    if (obj.platform == 'zhcx' || obj.platform == 'zcgl' || obj.platform == 'zygl' || obj.platform == 'zjbz' || obj.platform == 'kjhs') { //三资
      host = getEnv('SZ_ZX_API')
      arr.push({
        key: "sourceId",
        value: sourceId
      })
    } else if (obj.productFlag == '1') { //课证融通
      // { //三天下
      if (Object.keys(obj.beforePlatform).length) { //有平台参数
        let urlPath = ''
        if (obj.beforePlatform.platform === 'stx') {
          urlPath = obj.beforePlatform.urlPath
        }
        if (urlPath) {
          host = urlPath;
        } else {
          host = getEnv('STXDX_API')
        }
      } else { //无平台参数
        host = getEnv('STXDX_API')
      }
      // }
    } else { //单项训练
      host = getEnv('STXDX_API')
    }
  } else if (obj.productFlag == '3' || obj.productFlag == '7') { //实训
    console.log('实训=====',obj)
    let roleStr = ""
    obj.stationList.forEach((item) => {
      roleStr += item.code + ',';
    });
    arr = [
      { key: "classId", value: obj.classId },
      { key: "courseId", value: obj.courseId },
      { key: "mobile", value: obj.mobile },
      { key: "model", value: 'tm' },
      { key: "platform", value: obj.platform == 'kjhs' ? 'ctx' : obj.platform },
      { key: "questionId", value: obj.listItem.id },
      { key: "roles", value: roleStr.substring(0, roleStr.length - 1) },
      { key: "teamId", value: obj.teamId },
      { key: "time", value: obj.timestamp },
      { key: "userId", value: obj.userId },
    ];
    if (obj.platform == 'zhcx' || obj.platform == 'zcgl' || obj.platform == 'zygl' || obj.platform == 'zjbz' || obj.platform == 'kjhs') { //三资
      host = getEnv('SZ_SX_API')
      arr.push({
        key: "sourceId",
        value: sourceId
      })
    } else { //三天下
      host = getEnv('sx_API')
    }

  } else {
    host = ""
  }
  let param = {}; //请求传的参数

  // 参数排序
  arr.sort(sortNum('key'));
  // sign加密
  let sign = ""; //加密串
  let sha1sign = ""
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}&`;
    param[item.key] = item.value;
  });
  console.log('sha1sign',sha1sign)
  sha1sign = setSha1(sign.substring(0, sign.length - 1));
  param.sign = sha1sign;
  if (host) {
    // 冬冬需求：正式环境课证融通试题id如下时 ，修改跳转host
    // wjl 2022.5.9
    if (
      param.questionId == 1003463 ||
      param.questionId == 1006516 ||
      param.questionId == 1006519 ||
      param.questionId == 1006520 ||
      param.questionId == 1006198 ||
      param.questionId == 1006197 ||
      param.questionId == 1006196 ||
      param.questionId == 1006195 ||
      param.questionId == 1006158
    ) {
      host = 'https://ctxapidslxpro.cailian.net/ctx-portal/v1/cailian/zxInto'
    }

    await axios.post(host, qs.stringify(param)).then(res => {
      if (res.data.result) {
        iframeUrl = res.data.value;
      } else {
        Message({
          message: res.data.error.message,
          type: 'error',
          showClose: true
        })
      }
    }).catch(err => {
      console.log(err)
    })
  } else {
    iframeUrl = ""
  }
  return {...param, iframeUrl}
}

// 三资跳转
async function sanziJump(obj) {

  let iframeUrl = ''
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let catalogType = obj.catalogType || 'NONE'
  let teamId = 'NONE'
  let teamName = ''
  let roles = ''
  if (obj.myStation && obj.myStation[0]) {
    if (obj.myStation[0].teamId) {
      teamId = obj.myStation[0].teamId
    }
    teamName = obj.myStation[0].teamName
    roles = obj.myStation.map(item => item.code).join()
  }

  if (obj.productFlag === '1' || obj.productFlag === '2') { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag === '3' || obj.productFlag === '7') {  //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }

  let {
    paramsList
  } = obj;
  let host = "";
  let arr = [];
  let templateCode = ""

  let param = {}; //请求传的参数
  let data = {};
  if (obj.productFlag === '1' || obj.productFlag === '2') {
    host = getEnv('SZ_API')
    data = {
      userId: obj.userId,
      classId: obj.classId,
      userType: obj.userType,//--
      nickName: obj.nickname,
      className: obj.className,
      courseId: obj.courseId,
      mobile: obj.mobile,
      schoolId: obj.deptId,
      schoolName: obj.deptName,
      questionId: obj.listItem.id,
      platform: obj.platform, //参数值（ctx，zhcx，zcgl，zygl，dagl，zjbz）
      time: obj.timestamp,//毫秒时间戳
      sourceId: sourceId,//--
      examType: examType,//--
      // templates: templateCode,//--
    }
  }
  else if (obj.productFlag === '3' || obj.productFlag === '7') {
    host = getEnv('SZ_BS_API')
    data = {
      roles: roles,
      userId: obj.userId,
      nickName: obj.nickname,
      mobile: obj.mobile,
      teamId: teamId,
      teamName: teamName,
      classId: obj.classId,
      className: obj.className,
      schoolId: obj.deptId,
      schoolName: obj.deptName,
      courseId: obj.courseId,
      platform: obj.platform, //参数值（ctx，zhcx，zcgl，zygl，dagl，zjbz）
      time: obj.timestamp,//毫秒时间戳
      questionId: obj.listItem.id,
    }
  } else {
    return Promise.reject(Message({
      message: '不支持当前操作类型！',
      type: 'warning',
      showClose: true
    }))
  }

  Object.entries(data).forEach(([key, value]) => {
    arr.push({
      key,
      value
    })
  })


  // 参数排序
  arr.sort(sortNum('key'));
  // sign加密
  let sign = ""; //加密串
  let sha1sign = ""
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}&`;
    param[item.key] = item.value;
  });
  console.log('sha1sign',sha1sign)
  sha1sign = setSha1(sign.substring(0, sign.length - 1));
  param.sign = sha1sign;
  if (host) {
    // 冬冬需求：正式环境课证融通试题id如下时 ，修改跳转host
    // wjl 2022.5.9
    if (
      param.questionId == 1003463 ||
      param.questionId == 1006516 ||
      param.questionId == 1006519 ||
      param.questionId == 1006520 ||
      param.questionId == 1006198 ||
      param.questionId == 1006197 ||
      param.questionId == 1006196 ||
      param.questionId == 1006195 ||
      param.questionId == 1006158
    ) {
      host = 'https://ctxapidslxpro.cailian.net/ctx-portal/v1/cailian/zxInto'
    }

    await axios.post(host, qs.stringify(param)).then(res => {
      if (res.data.result) {
        iframeUrl = res.data.value;
      } else {
        Message({
          message: res.data.error.message,
          type: 'error',
          showClose: true
        })
      }
    }).catch(err => {
      console.log(err)
    })
  } else {
    iframeUrl = ""
  }
  return {...param, iframeUrl}
}

// 三天下RPA跳转
async function stxRpaJump(obj) {
  let iframeUrl = ''
  let {
    paramsList
  } = obj;
  let host = "";
  let arr = [];
  if (obj.productFlag == '1' || obj.productFlag == '2') { //单项
    let roleCode = ""
    let templateCode = ""
    if (paramsList.length > 0) {
      paramsList.forEach(v => {
        if (v.key === "templateCode") {
          templateCode = v.value
        }
        if (v.key === "roles") {
          roleCode = v.value
        }
      })
    }
    arr = [
      { key: "classId", value: obj.classId },
      { key: "courseId", value: obj.courseId },
      { key: "model", value: "zx" },
      { key: "num", value: obj.num },
      { key: "platform", value: obj.platform == 'kjhs' ? 'ctx' : obj.platform },
      { key: "questionId", value: obj.listItem.id },
      { key: "roles", value: roleCode },
      { key: "schoolId", value: obj.deptId },
      { key: "templateCode", value: templateCode },
      { key: "time", value: obj.timestamp },
      { key: "userId", value: obj.userId },
    ];
    if (obj.productFlag == '1') { //课证融通
      // { //三天下
      if (obj.num >= 1) { //无平台参数
        host = getEnv('STXZX_API')
      }
      // }
    } else { //单项训练
      host = getEnv('STXZX_API')
    }
  } else {
    host = ""
  }
  // 参数排序
  arr.sort(sortNum('key'));
  // sign加密
  let sign = ""; //加密串
  let param = {}; //请求传的参数
  let sha1sign = ""
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}&`;
    param[item.key] = item.value;
  });
  sha1sign = setSha1(sign.substring(0, sign.length - 1));
  param.sign = sha1sign;
  console.log(host)
  if (host) {
    // 冬冬需求：正式环境课证融通试题id如下时 ，修改跳转host
    // wjl 2022.5.9
    if (
      param.questionId == 1003463 ||
      param.questionId == 1006516 ||
      param.questionId == 1006519 ||
      param.questionId == 1006520 ||
      param.questionId == 1006198 ||
      param.questionId == 1006197 ||
      param.questionId == 1006196 ||
      param.questionId == 1006195 ||
      param.questionId == 1006158
    ) {
      host = 'https://ctxapidslxpro.cailian.net/ctx-portal/v1/cailian/zxInto'
    }

    await axios.post(host, qs.stringify(param)).then(res => {
      if (res.data.result) {
        iframeUrl = res.data.value;
      } else {
        Message({
          message: res.data.error.message,
          type: 'error',
          showClose: true
        })
      }
    }).catch(err => {
      console.log(err)
    })
  } else {
    iframeUrl = ""
  }
  return {...param, iframeUrl}
}

// 摩估云跳转
async function mgyJump(obj) {
  let {
    paramsList,
    stationList,
    teamId,
    teamName,
    platform,
    listItem
  } = obj;
  let host = "";
  let iframeUrl = "";
  let arr = [];
  let templateCode = "";
  let roles = "";
  if (paramsList.length > 0) {
    paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roles = v.value
      }
    })
  }
  if (obj.productFlag == '1' || obj.productFlag == '2') {
    arr = [
      { key: "classId", value: obj.classId },
      { key: "className", value: obj.className },
      { key: "courseId", value: obj.courseId },
      { key: "examType", value: examType },
      { key: "mobile", value: obj.mobile },
      { key: "model", value: "zx" },
      { key: "nickName", value: obj.nickname },
      { key: "platform", value: platform },
      { key: "questionId", value: listItem.id },
      { key: "roles", value: roles },
      { key: "schoolId", value: obj.deptId },
      { key: "schoolName", value: obj.deptName },
      { key: "templateCode", value: templateCode },
      { key: "time", value: obj.timestamp },
      { key: "userId", value: obj.userId },
      { key: "userType", value: obj.userType },
    ];
    host = getEnv('mgy_API')
  } else if (obj.productFlag == '3' || obj.productFlag == '7') {
    let roleStr = ""
    stationList.forEach((item) => {
      roleStr += item.code + ',';
    });
    arr = [
      { key: "classId", value: obj.classId },
      { key: "className", value: obj.className },
      { key: "courseId", value: obj.courseId },
      { key: "courseName", value: obj.courseName },
      { key: "examType", value: examType },
      { key: "mobile", value: obj.mobile },
      { key: "model", value: "tm" },
      { key: "nickName", value: obj.nickname },
      { key: "platform", value: platform },
      { key: "questionId", value: listItem.id },
      { key: "roles", value: roleStr.substring(0, roleStr.length - 1) },
      { key: "schoolId", value: sessionStorage.getItem("deptId") },
      { key: "schoolName", value: sessionStorage.getItem("deptName") },
      { key: "templateCode", value: templateCode },
      { key: "teamId", value: teamId },
      { key: "teamName", value: teamName },
      { key: "time", value: obj.timestamp },
      { key: "userId", value: sessionStorage.getItem('userId') },
      { key: "userType", value: obj.userType },
    ];
    host = getEnv('sx_MGY_API')
  } else {
    host = ""
  }
  // 参数排序
  arr.sort(sortNum('key'));
  // sign加密
  let sign = ""; //加密串
  let param = {}; //请求传的参数
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}&`;
    param[item.key] = item.value;
  });
  let sha1sign = setSha1(sign.substring(0, sign.length - 1));
  param.sign = sha1sign;
  if (host) {
    await axios.post(host, qs.stringify(param)).then(res => {
      if (res.data.result) {
        iframeUrl = res.data.value;
      } else {
        if (res.data.error) {
          Message({
            message: res.data.error.message,
            type: 'error',
            showClose: true
          })
        } else {
          Message({
            message: res.data.msg,
            type: 'error',
            showClose: true
          })
        }
      }
    }).catch(err => {
      console.log(err)
    })
  } else {
    iframeUrl = ""
  }
  return {...param, iframeUrl}
}

// 摩估云-中级跳转
async function middleMGYJump(obj) {
  let {
    paramsList,
    platform,
    listItem
  } = obj;
  let host = "";
  let iframeUrl = "";
  let arr = [];
  if (obj.productFlag == '1' || obj.productFlag == '2') {
    let templateCode = "";
    let roles = ""
    if (paramsList.length > 0) {
      paramsList.forEach(v => {
        if (v.key == "templateCode") {
          templateCode = v.value
        }
        if (v.key == "roles") {
          roles = v.value
        }
      })
    }
    arr = [
      { key: "classId", value: obj.classId },
      { key: "className", value: obj.className },
      { key: "courseId", value: obj.courseId },
      { key: "examType", value: examType },
      { key: "mobile", value: obj.mobile },
      { key: "model", value: "zx" },
      { key: "nickName", value: obj.nickname },
      { key: "platform", value: platform },
      { key: "questionId", value: listItem.id },
      { key: "roles", value: roles },
      { key: "schoolId", value: obj.deptId },
      { key: "schoolName", value: obj.deptName },
      { key: "templateCode", value: templateCode },
      { key: "time", value: obj.timestamp },
      { key: "userId", value: obj.userId },
      { key: "userType", value: obj.userType },
    ];
    host = getEnv('mgy_API_ZJ')
  } else {
    host = ""
  }
  // 参数排序
  arr.sort(sortNum('key'));
  // sign加密
  let sign = ""; //加密串
  let param = {}; //请求传的参数
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}&`;
    param[item.key] = item.value;
  });
  let sha1sign = setSha1(sign.substring(0, sign.length - 1));
  param.sign = sha1sign;
  if (host) {
    await axios.post(host, qs.stringify(param)).then(res => {
      if (res.data.result) {
        iframeUrl = res.data.value;
      } else {
        Message({
          message: res.data.msg,
          type: 'error',
          showClose: true
        })
      }
    }).catch(err => {
      console.log(err)
    })
  } else {
    iframeUrl = ""
  }
  return {...param, iframeUrl}
}

// 摩估云-估值应用跳转
async function gzyyJump(obj) {
  let {
    paramsList,
    listItem
  } = obj;
  let host = "";
  let iframeUrl = "";
  let arr = [];
  if (obj.productFlag == '1' || obj.productFlag == '2') {
    let roles = ""
    if (paramsList.length > 0) {
      paramsList.forEach(v => {
        if (v.key == "role") {
          roles = v.value
        }
      })
    }
    arr = [
      { key: "classId", value: obj.classId },
      { key: "className", value: obj.className },
      { key: "courseId", value: obj.courseId },
      { key: "model", value: "dx" },
      { key: "questionId", value: listItem.id },
      { key: "role", value: roles },
      { key: "schoolId", value: obj.deptId },
      { key: "schoolName", value: obj.deptName },
      { key: "time", value: obj.timestamp },
      { key: "userId", value: obj.userId },
      { key: "userName", value: obj.nickname },
      { key: "projectId", value: 1 },
      { key: "projectName", value: '课程1' },
    ];
    host = getEnv('STX_PG_API')
  } else {
    host = ""
  }
  // 参数排序
  arr.sort(sortNum('key'));
  // sign加密
  let sign = ""; //加密串
  let param = {}; //请求传的参数
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}&`;
    param[item.key] = item.value;
  });
  let sha1sign = setSha1(sign.substring(0, sign.length - 1));
  param.sign = sha1sign;
  if (host) {
    await axios.post(host, qs.stringify(param)).then(res => {
      if (res.data.result) {
        iframeUrl = res.data.value;
      } else {
        Message({
          message: res.data.error.message,
          type: 'error',
          showClose: true
        })
      }
    }).catch(err => {
      console.log(err)
    })
  } else {
    iframeUrl = ""
  }
  return {...param, iframeUrl}
}

// 政务仿真跳转
async function zwfzJump(obj) {
  let {
    listItem,
    courseId,
    classId,
    nickname,
    token
  } = obj;
  let iframeUrl = ''

  if (obj.questionDto && obj.questionDto.eventTemplate && obj.questionDto.eventTemplate.eventUrl) {
    iframeUrl = obj.questionDto.eventTemplate.eventUrl +
      `&token=${token}&paperId=${listItem.paperId}&questionId=${listItem.id}&courseId=${courseId}&classId=${classId}&userName=${nickname}`;
  } else if (listItem.templates && listItem.templates[eventSort]) {
    let url = listItem.templates[eventSort].eventTemplateUrl;
    iframeUrl = `${url}?token=${token}&examType=${examType}&courseId=${courseId}&questionId=${listItem.id}&classId=${classId}&userName=${nickname}`
  }

  if (iframeUrl.includes('/#/')) {
    return {...obj, iframeUrl, type: "fz"}
  } else {
    Message({
      message: '跳转配置错误',
      type: 'error',
      showClose: true
    })
  }

}

// 中联集团登录参数
async function zljtLoginParams(obj, sys) {
  /*
    encrypted拼接规则: (示例: TEACH_123_999_2_200_001)
    系统: （教学: TEACH）、（考试: EXAMS）、（大赛: MATCH）、（业财一体化：YCYT ）
    123: (教学: courseId)、（考试: NONE）、（大赛: NONE）
    999: (教学: classId)、（考试: examPlanId）、（大赛: examPlanId）
    2: (单项: 1)、（实训: 2）
    200: (单项: NONE)、（实训: teamId）
    001: templateCode
  */
  let {clientId, productFlag, courseId, classId, myStation, paramsList, beforePlatform, userId} = obj
  let encrypted = ""
  let identity = sys
  let roleCode = ""
  let templateCode = ""
  let ifTittleShow = ""   // ifTittleShow=1   是否展示excel表头（工具栏）
  let applyScene = ""   //  应用场景 （最初用于审计， 事项 Excel在审计中的应用 上有这个动态参数） 东东加2023.1.5
  let ifSave = ""    // ifSave=1    是否显示 保存或审核 按钮
  let saveStructure = '' // 新标准 和 旧标准 （excel 单元格 新 {}， 旧 sheet//col//row）

  if (sys == 'szjr' || sys == 'dsfz') {
    if (productFlag == 1 || productFlag == 2) { //单项
      // identity = sys + 'dx'
      encrypted = `TEACH_${courseId}_${classId}_1_${userId}`
    } else if (productFlag == 3 || productFlag == 7) {   // 综合
      // identity = sys + 'zh'
      // // 新的跳转方式
      // if (beforePlatform && beforePlatform.urlPath.includes('api-oauth/v1/oauth/ycyt2/oauth/token')) {
      //   identity = sys
      //   encrypted = `YCYT_${courseId}_${classId}_4_${myStation[0].teamId}`
      // } else {
      //   encrypted = `TEACH_${courseId}_${classId}_2_${myStation[0].teamId}`
      // }
      encrypted = `TEACH_${courseId}_${classId}_2_${myStation[0].teamId}`

    }
  } else {
    if (productFlag == 1 || productFlag == 2) { //单项
      // identity = sys + 'dx'
      if(sys == 'ds' && examType==15){
        encrypted = `TEACH_${courseId}_${classId}_1_${userId}`
      }else{
        encrypted = `TEACH_${courseId}_${classId}_1_NONE`
      }
    } else if (productFlag == 3 || productFlag == 7) {   // 综合
      // identity = sys + 'zh'
      // // 新的跳转方式
      // if (beforePlatform && beforePlatform.urlPath.includes('api-oauth/v1/oauth/ycyt2/oauth/token')) {
      //   identity = sys
      //   encrypted = `YCYT_${courseId}_${classId}_4_${myStation[0].teamId}`
      // } else {
      //   encrypted = `TEACH_${courseId}_${classId}_2_${myStation[0].teamId}`
      // }
      encrypted = `TEACH_${courseId}_${classId}_2_${myStation[0].teamId}`

    }
  }

  // /* 获取当前事项的详情, 拿到需要的参数 */
  // let eventDetail = await getEventDetail(obj.listItem);
  // if (eventDetail) {
  //   let eventParam = eventDetail.eventParam;
  //   applyScene = getQuery2object('applyScene', eventParam)
  //   ifTittleShow = getQuery2object('ifTittleShow', eventParam)
  //   ifSave = getQuery2object('ifSave', eventParam)
  // }

  // if (sys === 'ChinaGovTaxApply') { // (税务仿真平台)  自然人电子税务局（扣缴端） 跳转
  //   identity = sys
  // }
  if (paramsList.length > 0) {
    paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      } else if (v.key === "roles") {
        roleCode = v.value
      } else if (v.key === "applyScene") {
        applyScene = v.value
      } else if (v.key === "ifTittleShow") {
        ifTittleShow = v.value
      } else if (v.key === "ifSave") {
        ifSave = v.value
      } else if (v.key === "saveStructure") {
        saveStructure = v.value
      }
    })
  }
  let arr = [
    { key: "clientId", value: clientId },
    { key: "encrypted", value: encrypted },
    { key: "identity", value: identity },
    { key: "item", value: obj.item },
    { key: "qstId", value: obj.listItem.id },
    { key: "roleCode", value: roleCode },
    { key: "templateCode", value: templateCode },
    { key: "timeStamp", value: obj.timestamp },
    { key: "token", value: obj.token },
    { key: "userType", value: obj.userType },
    { key: "username", value: obj.username },

  ];
  // sign加密
  let sign = ""; //加密串
  let param = new Object(); //请求传的参数
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}, `;
    param[item.key] = item.value;
  });
  let signStr = `{${sign.substring(0, sign.length - 2)}}`
  let sha1sign = setSha1(signStr, '02424D4FD04A007E453DADA28E4EEE37');
  param.sign = sha1sign;
  param.userId = obj.userId;
  param.courseId = obj.courseId;
  param.classId = obj.classId;
  param.teamId = obj.teamId;
  param.examType = examType;
  param.ifTittleShow = ifTittleShow;
  param.applyScene = applyScene;
  param.saveStructure = saveStructure;
  param.ifSave = ifSave;

  if ((sys == 'sj' || sys == 'ds' || sys == 'zlbi' || sys == 'pclive') && examType === 15) {
    param.userCode = obj.userId
  }
  return param
}

/**
 * 获取试题中事项的 详情。拿到配置的参数
 * 只获取当前事项的详情
 * 2023.1.5
 */
// function getEventDetail(q) {
//   if (q.model == 'cy') {
//     eventSort = 0
//   }
//   let t = q.templates;
//   if (t && t[eventSort]) {
//     let e = t[eventSort].id;
//     let param = {
//       url: `${ getEnv('BASE_API') }/api-resource/repeat/eventTemplate/?ids=${e}`,
//       method: "GET",
//       headers: {
//         "Authorization": 'bearer ' + localStorage.getItem('Authorization'),
//       }
//     };
//     return axios.request(param).then(res => {
//       if (res.data.code === '0' && res.data.data && res.data.data.length) {
//         return res.data.data[0]
//       } else {
//         return null
//       }
//     })
//   }
// }

/**
 *  平台跳转所需参数
 *  先获取了平台token，又整合了业务系统和埋点需要的 所有参数
 *  author: wjl  2022.8.25
 **/
async function getParams(obj) {
  /*
    encrypted拼接规则: (示例: TEACH_123_999_2_200_001)
    系统: （教学: TEACH）、（考试: EXAMS）、（大赛: MATCH）
    123: (教学: courseId)、（考试: NONE）、（大赛: NONE）
    999: (教学: classId)、（考试: examPlanId）、（大赛: examPlanId）
    2: (单项: 1)、（实训: 2）
    200: (单项: NONE)、（实训: teamId）
    001: templateCode
  */

  let encrypted = ""
  let identity = ""
  let roleCode = ""
  let templateCode = ""

  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag === '1' || obj.productFlag === '2') { //单项
    identity = obj.platform + 'dx'
    encrypted = `TEACH_${obj.courseId}_${obj.classId}_1_NONE`
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag === '3' || obj.productFlag === '7') {  //综合
    identity = obj.platform + 'zh'
    encrypted = `TEACH_${obj.courseId}_${obj.classId}_2_${obj.myStation[0].teamId}`
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }
  // if (obj.platform === 'ChinaGovTaxApply') {
  //   identity = obj.platform
  // }
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  let signObj = {
    clientId: obj.clientId,
    encrypted: encrypted,
    identity: identity,
    item: obj.item,
    qstId: obj.listItem.id,
    roleCode: roleCode,
    templateCode: templateCode,
    timeStamp: obj.timestamp,
    token: obj.token,
    userType: obj.userType,
    username: obj.username,
  }
  // sign加密
  let signString = ""; //加密串

  for (const key in signObj) {
    signString += `${key}=${signObj[key]}, `;
  }

  let signJson = `{${signString.substring(0, signString.length - 2)}}`
  let sign = setSha1(signJson, '02424D4FD04A007E453DADA28E4EEE37');

  //请求传的参数
  let params = {
    sign,
    encrypted,
    identity,
    roleCode,
    templateCode,
    clientId: obj.clientId,
    item: obj.item,
    qstId: obj.listItem.id,
    timeStamp: obj.timestamp,
    token: obj.token,
    sex: obj.sex,
    userId: obj.userId,
    userType: obj.userType,
    username: obj.username,
    deptId: obj.deptId,
    deptName: obj.deptName,
  };
  if(examType === 15){
    params['userCode'] = obj.userId
  }
  // 获取中联用户token。
  return axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, params).then(res => {
    if (res.data.code === 0) {
      return {
        ...obj,
        ...params,
        access_token: res.data.data.access_token,
        sourceId,
        examType,
        platform: obj.platform
      }
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
      return {}
    }
  })

}

// 商旅跳转
async function shanglvJump(obj) {
  let iframeUrl = ''

  // 获取所需参数
  let param = await zljtLoginParams(obj, 'sl').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let slParams = `qstId=${obj.listItem.id}&token=${res.data.data.access_token}&nickname=${Base64.encode(obj.nickname)}`
      let src = `${ getEnv('XSL_API') }?${slParams}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })

  return {...param, iframeUrl}
}

// 审计跳转
async function sjJump(obj) {
  let iframeUrl = ''

  // 获取所需参数
  let param = await zljtLoginParams(obj, 'sj').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let jumpStr = `token=${res.data.data.access_token}&productFlag=${obj.productFlag}&gxzxToken=${obj.token}`
      let src = `${ getEnv('XSJ_API') }?${Base64.encode(jumpStr)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 电商实训跳转
async function dsJump(obj) {
  let menuCode = []
  if (obj.listItem) {
    // if(obj.listItem.model == "cy"){
    //   console.log(obj)
    //   if(obj.paramsList.length > 0){
    //     obj.paramsList.forEach(v => {
    //       if(v.key == "menuCode"){
    //         menuCode = v.value.split(',')
    //       }
    //     })
    //   }
    // }else{
      if(obj.listItem.templates.length > 0){
        obj.listItem.templates.forEach(v => {
          let arr = v.eventParam.split("&")
          arr.forEach(n => {
            if (n.split("=")[0] == "menuCode") {
              menuCode.push(n.split("=")[1])
            }
          })
        })
      }
    // }
  }
  console.log('menuCode', menuCode)

  let iframeUrl = ''

  // 获取所需参数
  let param = await zljtLoginParams(obj, 'ds').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      //  keyId 小组Id
      //  isTeamShare 团队是否共享
      // 电商实训传参加试题id。   2022.3.18  wjl

      let dsParam = {
        token: res.data.data.access_token,
        gxzxToken: obj.token,
        userId: obj.userId,
        isTeamShare: 0,
        keyId: obj.teamId,
        roleCode: param.roleCode,
        // templateCode: param.templateCode,
        sourceId: param.encrypted,
        menuCode: menuCode.length > 0 ? menuCode.join(',') : "",
        id: obj.listItem.id,
        nickname: Base64.encode(obj.nickname),
        productCode: obj.beforePlatform.code,
        productName: Base64.encode(obj.beforePlatform.tag),
        templateCode: param.templateCode,
      }

      let dsParamStr = ""
      for (let key in dsParam) {
        dsParamStr += (key + "=" + dsParam[key] + "&")
      }

      let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
      let src = `${ getEnv('DS_API') }/#/?${Base64.encode(jumpStr)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 电商调研跳转
async function dsfzJump(obj) {
  let iframeUrl = ''
  let sort = 0
  if (obj.listItem.templates && obj.listItem.templates.length > 1) {
    sort = eventSort
  } else {
    sort = 0
  }
  let url = obj.listItem.templates[sort].eventTemplateUrl;

  let templateCode = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let roleCode = "";
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  // 获取所需参数
  let param = await zljtLoginParams(obj, 'dsfz').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        userId: obj.userId,
        teamId: obj.teamId,
        roleCode: roleCode,
        templateCode: templateCode,
        nickname: Base64.encode(obj.nickname),
        sourceId: param.encrypted,
        keyId: obj.userId,
        newSourceId: sourceId,
        questionId: obj.listItem.id,
        token: res.data.data.access_token,
        sxToken: obj.token,
        clientId: "1349883712819109890",
        orgId: obj.deptId,
        userCode: obj.userId,
        userType: obj.userType,
        examType: examType,
        examPlan: '',
        paperCode: '',
        item: "",
        courseId: obj.courseId,
        classId: obj.classId,
        timestamp: obj.timestamp,
      }

      let ParamStr = ""
      for (let key in params) {
        ParamStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = ParamStr.substring(0, ParamStr.length - 1)
      // let Base64url = `keyId=${obj.userId}&sourceId=${param.encrypted}&questionId=${obj.listItem.id}&token=${res.data.data.access_token}`;
      let src = `${ getEnv('PRO_API') }/#${url}?${jumpStr}`;
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 商务数据分析跳转
async function swsjfxJump(obj) {
  let menuCode = []
  let directedUrl = ""
  let eventTemplateUrl = ""
  if (obj.listItem && obj.listItem.templates.length > 0) {
    eventTemplateUrl = obj.listItem.templates[0].eventTemplateUrl
    obj.listItem.templates.forEach(v => {
      let arr = v.eventParam.split("&")
      arr.forEach(n => {
        if (n.split("=")[0] == "menuCode") {
          menuCode.push(n.split("=")[1])
        }
        if (n.split("=")[0] == "url") {
          directedUrl = n.split("=")[1]
        }
      })
    })
  }

  let iframeUrl = '';
  // 获取所需参数
  let param = await zljtLoginParams(obj, 'ds').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      //  keyId 小组Id
      //  isTeamShare 团队是否共享

      let dsParam = {
        token: res.data.data.access_token,
        gxzxToken: obj.token,
        userId: obj.userId,
        userType: obj.userType,
        deptId: obj.deptId,
        professional: sessionStorage.getItem('professional'),
        examType: examType,
        isTeamShare: 0,
        keyId: obj.teamId,
        roleCode: param.roleCode,
        templateCode: param.templateCode,
        sourceId: param.encrypted,
        menuCode: menuCode.length > 0 ? menuCode.join(',') : "",
        directedUrl: directedUrl,
        eventTemplateUrl: eventTemplateUrl,
        id: obj.listItem.id,
        item: param.item,
        // tenant_path: obj.tenant_path,
        nickname: Base64.encode(obj.nickname)
      }

      let dsParamStr = ""
      for (let key in dsParam) {
        dsParamStr += (key + "=" + dsParam[key] + "&")
      }

      let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
      let src = `${ getEnv('SWSJFX_API') }/#/?${Base64.encode(jumpStr)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}

// 数字金融业务系统
async function szjrywJump(obj) {
  let iframeUrl = '';
  let templateCode = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let roleCode = ""
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  let clientSecret = '02424D4FD04A007E453DADA28E4EEE37';
  let md5sign = `clientSecret=${clientSecret}&questionId=${obj.listItem.id}&sourceId=${sourceId}&timestamp=${obj.timestamp}&token=${obj.token}`;
  let sign = MD5(md5sign)

  let param = await zljtLoginParams(obj, 'szjr').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        clientId: "1349883712819109890",
        orgId: obj.deptId,
        userCode: obj.userId,
        userId: obj.userId,
        userType: obj.userType,
        examType: examType,
        examPlan: '',
        paperCode: '',
        questionId: obj.listItem.id,
        item: "",
        courseId: obj.courseId,
        classId: obj.classId,
        teamId: obj.teamId,
        roleCode: roleCode,
        timestamp: obj.timestamp,
        token: obj.token,
        sourceId: sourceId,
        identity: "szjr",
        environment: "sx",
        platform: 'DigitalFinanceOS',
        extend: '',
        sign: sign,
        templateCode: templateCode,
        nickname: Base64.encode(obj.nickname),
        encrypted: param.encrypted,
        zljtToken: res.data.data.access_token,
      }

      let dsParamStr = ""
      for (let key in params) {
        dsParamStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
      let src = `${ getEnv('SZJR_WEB') }/#/?${Base64.encode(jumpStr)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}
//jxl单独跳转
async function tage3_Jump(obj){
  console.log(obj,"objobj------------jxl")
  let iframeUrl = '';
  let templateCode = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let roleCode = "";
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'
  sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_NONE_${obj.userId}_NONE_0_${obj.listItem.id}`
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }
  let clientSecret = '02424D4FD04A007E453DADA28E4EEE37';
  let md5sign = `clientSecret=${clientSecret}&questionId=${obj.listItem.id}&sourceId=${sourceId}&timestamp=${obj.timestamp}&token=${obj.token}`;
  let sign = MD5(md5sign)

  let param = await zljtLoginParams(obj, 'szjr').then(res => {
    console.log(res)
    return res
  })
  // param.encrypted = sourceId
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        clientId: "1349883712819109890",
        orgId: obj.deptId,
        userCode: obj.userId,
        userId: obj.userId,
        userType: obj.userType,
        examType: examType,
        examPlan: '',
        paperCode: '',
        questionId: obj.listItem.id,
        item: "",
        courseId: obj.courseId,
        classId: obj.classId,
        teamId: obj.teamId,
        roleCode: roleCode,
        timestamp: obj.timestamp,
        token: obj.token,
        sourceId: sourceId,
        identity: "szjr",
        environment: "sx",
        platform: obj.platform,
        extend: '',
        sign: sign,
        templateCode: templateCode,
        nickname: Base64.encode(obj.nickname),
        encrypted: param.encrypted,
        zljtToken: res.data.data.access_token,
        catalogType: obj.catalogType,
      }

      tage3_JumpFn(params).then(result=>{
        iframeUrl = result
      })
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}
// 赛段三拆分跳转
async function JR3_Jump(obj) {
  let iframeUrl = '';
  let templateCode = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let roleCode = "";
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'
  console.log(obj,"---------------")
  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_NONE_${obj.userId}_NONE_0_${obj.listItem.id}`
    // sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}_0_${obj.listItem.id}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  let clientSecret = '02424D4FD04A007E453DADA28E4EEE37';
  let md5sign = `clientSecret=${clientSecret}&questionId=${obj.listItem.id}&sourceId=${sourceId}&timestamp=${obj.timestamp}&token=${obj.token}`;
  let sign = MD5(md5sign)

  let param = await zljtLoginParams(obj, 'szjr').then(res => {
    console.log(res)
    return res
  })
  // param.encrypted = sourceId
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        clientId: "1349883712819109890",
        orgId: obj.deptId,
        userCode: obj.userId,
        userId: obj.userId,
        userType: obj.userType,
        examType: examType,
        examPlan: '',
        paperCode: '',
        questionId: obj.listItem.id,
        item: "",
        courseId: obj.courseId,
        classId: obj.classId,
        teamId: obj.teamId,
        roleCode: roleCode,
        timestamp: obj.timestamp,
        token: obj.token,
        sourceId: sourceId,
        identity: "szjr",
        environment: "sx",
        platform: obj.platform,
        extend: '',
        sign: sign,
        templateCode: templateCode,
        nickname: Base64.encode(obj.nickname),
        encrypted: param.encrypted,
        zljtToken: res.data.data.access_token,
        catalogType: obj.catalogType,
      }

      jumpFn(params).then(result=>{
        iframeUrl = result
      })
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}
async function tage3_JumpFn(jumpParam){
  console.log(jumpParam,"jumpParam111111111111111111111111111")
  let type = ""
  switch (jumpParam.platform) {
    case 'BlockchainFinance':
      type = "链设计"
      break;
    case 'ZcSecuritization':
      type = "资产证券化"
      break;
    case 'HangkongInsurance':
      type = "航空延误、意外险"
      break;
    case 'BlockchainInvoice':
      type = "区块链发票"
      break;
    case 'NongcpSupplychain':
      type = "农产品供应链"
      break;
    default:
      break;
  }
  let host = ""
  let url = ""
  let zljtToken = jumpParam.zljtToken.substring(0, 36);
  let pattern = 1;
  let teamId = (jumpParam.myStation && jumpParam.myStation[0]) ? jumpParam.myStation[0].teamId ? jumpParam.myStation[0].teamId : 'NONE' : 'NONE'
  let params = {}
  let repeatParams = {//所有
    questionId: jumpParam.questionId,
    userId: jumpParam.userId,
  }
  let eduParams = {//云金融、大数据、航空险、资产证券化、链设计、发票、农产品、链审计、大财富、数字保险、数字金融、数字监管
    product: Base64.encode(type),
    clientId: jumpParam.clientId,
    identity: jumpParam.identity,
    item: jumpParam.item,
    roleCode: jumpParam.roleCode,
    templateCode: jumpParam.templateCode,//证券、客户画像
    timeStamp: jumpParam.timestamp,
    userType: jumpParam.userType,
    courseId: jumpParam.courseId,
    classId: jumpParam.classId,
    teamId: jumpParam.teamId,
    examType: examType,
    examPlan: jumpParam.examPlan,
    orgId: jumpParam.orgId,
    sign: jumpParam.sign,
    pattern: pattern,//数字人名币、跨境金融、数字银行、数字证券
    token: jumpParam.token,
    userCode: jumpParam.userCode,
    platform: jumpParam.platform,
    username: Base64.encode(jumpParam.nickname),
    questionId:jumpParam.questionId,
    userId:jumpParam.userId,
  }
  eduParams.sourceId = `4_${jumpParam.courseId}_${jumpParam.classId}_NONE_${teamId}_${jumpParam.userId}_${jumpParam.catalogType}_0_${jumpParam.questionId}`
  switch (type) {
    case '航空延误、意外险':
      host = getEnv('QKLJRYW_WEB')
      params = eduParams
      break;
    case '资产证券化':
      host = getEnv('QKLABS_WEB')
      params = eduParams
      break;
    case '链设计':
      // host = process.env.QKLDESIGN_WEB
      host = getEnv('QKLDESIGN_WEB')
      params = eduParams
      break;
    case '区块链发票':
      // host = process.env.QKLINVOCIE_WEB
      host = getEnv('QKLINVOCIE_WEB')
      params = eduParams
      break;
    case '农产品供应链':
      // host = process.env.QKLSUPPLY_WEB
      host = getEnv('QKLSUPPLY_WEB')
      params = eduParams
      break;
    default:
      break;
  }
  if(host==""){
    return
  }

  let dsParamStr = ""
  for (let key in params) {
    dsParamStr += (key + "=" + params[key] + "&")
  }
  let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
  let src = ""
  if(url){
    src = `${host}/#/${url}?${jumpStr}`
  }else{
    if(jumpParam.platform == 'PersonPictureOS'){
      src = `${host}/#/?${Base64.encode(jumpStr)}`
    }else{
      src = `${host}/#/?${jumpStr}`
    }
  }
  return src
}


async function jumpFn(jumpParam){
  let type = ""
  switch (jumpParam.platform) {
    case 'CloudFinance':
      type = "云金融"
      break;
    case 'BigDataFinance':
      type = "大数据"
      break;
    case 'BlockchainFinance':
      type = "链设计"
      break;
    case 'ZcSecuritization':
      type = "资产证券化"
      break;
    case 'HangkongInsurance':
      type = "航空延误、意外险"
      break;
    case 'BlockchainInvoice':
      type = "区块链发票"
      break;
    case 'NongcpSupplychain':
      type = "农产品供应链"
      break;
    case 'BlockchainAudit':
      type = "链审计"
      break;
    case 'DigitalPayment':
      type = "数字人民币"
      break;
    case 'CrossborderFinance':
      type = "跨境金融"
      break;
    case 'DigitalBank':
      type = "数字银行"
      break;
    case 'BigwealthManagement':
      type = "大财富管理"
      break;
    case 'DigitalSecurity':
      type = "数字证券"
      break;
    case 'DigitalInsurance':
      type = "数字保险"
      break;
    case 'FinanceTechNew':
      type = "数字金融"
      break;
    case 'FinancialRegulation':
      type = "数字监管"
      break;
    case 'PersonPictureOS':
      type = "客户画像" //数字银行-客户画像
      break;
    case 'BlockCrossborderFinance':
      type = "跨境金融2" //新-跨境金融
      break;
    case 'FinanceManageAccount':
      type = "智慧金融绩效管理" //新-跨境金融
      break;
    case 'SupplyChainFinanceOS2024':
      type = "金融供应链实操系统" //金融供应链实操系统
      break;
    default:
      break;
  }
  let host = ""
  let url = ""
  let zljtToken = jumpParam.zljtToken.substring(0, 36);
  let pattern = 1;
  let teamId = (jumpParam.myStation && jumpParam.myStation[0]) ? jumpParam.myStation[0].teamId ? jumpParam.myStation[0].teamId : 'NONE' : 'NONE'
  let params = {}
  let repeatParams = {//所有
    questionId: jumpParam.questionId,
    userId: jumpParam.userId,
  }
  let zljtParams = {//云金融、大数据、航空险、资产证券化、链设计、发票、农产品、链审计、数字人民币、跨境金融、数字保险、数字金融、数字监管
    product: Base64.encode(type),
  }
  let zljtParams2 = {//云金融、大数据、数字人民币、跨境金融、数字银行、大财富、数字证券、跨境金融2
    token: zljtToken,
    // sourceId: `4_${jumpParam.courseId}_${jumpParam.classId}_NONE_${teamId}_NONE_${jumpParam.userId}_NONE_0_${jumpParam.questionId}`,
    // encrypted: `4_${jumpParam.courseId}_${jumpParam.classId}_NONE_${teamId}_NONE_${jumpParam.userId}_NONE_0_${jumpParam.questionId}`,
    sourceId: jumpParam.encrypted,
  }
  let eduParams = {//云金融、大数据、航空险、资产证券化、链设计、发票、农产品、链审计、大财富、数字保险、数字金融、数字监管
    clientId: jumpParam.clientId,
    identity: jumpParam.identity,
    item: jumpParam.item,
    roleCode: jumpParam.roleCode,
    templateCode: jumpParam.templateCode,//证券、客户画像
    timeStamp: jumpParam.timestamp,
    userType: jumpParam.userType,
    courseId: jumpParam.courseId,
    classId: jumpParam.classId,
    teamId: jumpParam.teamId,
    examType: examType,
    examPlan: jumpParam.examPlan,
    orgId: jumpParam.orgId,
    sign: jumpParam.sign,
    pattern: pattern,//数字人名币、跨境金融、数字银行、数字证券
  }
  let eduParams2 = {//航空险、资产证券化、链设计、发票、农产品、链审计、大财富、数字保险、数字金融、数字监管、
    platform: jumpParam.platform,
    username: Base64.encode(jumpParam.nickname),
  }
  let eduParams3 = {//航空险、资产证券化、链设计、发票、农产品、链审计、数字保险、数字金融、数字监管
    token: jumpParam.token,
    sourceId: jumpParam.sourceId,
  }
  let eduParams4 = {//航空险、资产证券化、链设计、发票、农产品、链审计
    userCode: jumpParam.userCode,
  }
  switch (type) {
    case '云金融':
      // host = process.env.DSJJRYW_WEB
      host = getEnv('DSJJRYW_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...zljtParams2,
        ...eduParams,
        nickname: Base64.encode(jumpParam.nickname),
        productIdEntity: "khhxDSJJR",
        roleIdentity: "ALL",
        sysIdentity: "SWSJFX"
      };
      break;
    case '大数据':
      // host = process.env.DSJJRYW_WEB
      host = getEnv('DSJJRYW_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...zljtParams2,
        ...eduParams,
        nickname: Base64.encode(jumpParam.nickname),
        productIdEntity: "khhxDSJJR",
        roleIdentity: "ALL",
        sysIdentity: "SWSJFX"
      };
      break;
    case '航空延误、意外险':
      // host = process.env.QKLJRYW_WEB
      host = getEnv('QKLJRYW_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
        ...eduParams4,
      };
      break;
    case '资产证券化':
      // host = process.env.QKLABS_WEB
      host = getEnv('QKLABS_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
        ...eduParams4,
      };
      break;
    case '链设计':
      // host = process.env.QKLDESIGN_WEB
      host = getEnv('QKLDESIGN_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
        ...eduParams4,
      };
      break;
    case '区块链发票':
      // host = process.env.QKLINVOCIE_WEB
      host = getEnv('QKLINVOCIE_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
        ...eduParams4,
      };
      break;
    case '农产品供应链':
      // host = process.env.QKLSUPPLY_WEB
      host = getEnv('QKLSUPPLY_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
        ...eduParams4,
      };
      break;
    case '链审计':
      // host = process.env.PRO_API
      host = getEnv('PRO_API')
      url = "lsj"
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
        ...eduParams4,
      };
      break;
    case '数字人民币':
      // host = process.env.ZFYWSZH_WEB
      host = getEnv('ZFYWSZH_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...zljtParams2,
        nickname: Base64.encode(jumpParam.nickname),
        pattern: pattern,
      };
      break;
    case '跨境金融':
      // host = process.env.ZFYWSZH_WEB
      host = getEnv('ZFYWSZH_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...zljtParams2,
        nickname: Base64.encode(jumpParam.nickname),
        pattern: pattern,
      };
      break;
    case '数字银行':
      // host = process.env.YHYWSZH_WEB
      host = getEnv('YHYWSZH_WEB')
      params = {
        ...repeatParams,
        ...zljtParams2,
        nickname: Base64.encode(jumpParam.nickname),
        product: Base64.encode(Base64.encode(type)),
        pattern: pattern,
      };
      break;
    case '大财富管理':
      // host = process.env.YHYWSZH_WEB
      host = getEnv('YHYWSZH_WEB')
      params = {
        ...repeatParams,
        ...zljtParams2,
        ...eduParams,
        ...eduParams2,
        product: Base64.encode(Base64.encode(type)),
      };
      break;
    case '数字证券':
      // host = process.env.ZQYWSZH_WEB
      host = getEnv('ZQYWSZH_WEB2')
      params = {
        ...repeatParams,
        ...zljtParams2,
        nickname: Base64.encode(jumpParam.nickname),
        product: Base64.encode(Base64.encode(type)),
        pattern: pattern,
        templateCode: jumpParam.templateCode,
        productIdEntity: "khhxDSJJR",
        roleIdentity: "ALL",
        sysIdentity: "SWSJFX"
      };
      break;
    case '数字保险':
      // host = process.env.BXYWSZH_WEB
      host = getEnv('BXYWSZH_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
      };
      break;
    case '数字金融':
      // host = process.env.JRKJYWCX_WEB
      host = getEnv('JRKJYWCX_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
      };
      break;
    case '数字监管':
      // host = process.env.SZJRYWJG_WEB
      host = getEnv('SZJRYWJG_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...eduParams,
        ...eduParams2,
        ...eduParams3,
      };
      break;
    case '客户画像':
      // host = process.env.PRESON_PIC_API
      host = getEnv('PRESON_PIC_API')
      params = {
        ...repeatParams,
        token: zljtToken,
        nickname: Base64.encode(jumpParam.nickname),
        sourceId: jumpParam.sourceId,
        templateCode: jumpParam.templateCode,
        productIdEntity: 'khhxYHYW',
        roleIdentity: 'ALL',
      };
      break;
    case '跨境金融2':
      // host = process.env.ZFYWSZH_WEB2
      host = getEnv('ZFYWSZH_WEB2')
      params = {
        ...repeatParams,
        ...zljtParams2,
        nickname: Base64.encode(jumpParam.nickname),
        product: Base64.encode('跨境金融'),
        pattern: pattern,
      };
      break;
    case '智慧金融绩效管理':
      // host = process.env.ZFYWSZH_WEB2
      host = getEnv('ZHJRJXGL_WEB')
      params = {
        ...repeatParams,
        ...zljtParams2,
        nickname: Base64.encode(jumpParam.nickname),
        product: Base64.encode('智慧金融绩效管理'),
        pattern: pattern,
      };
      break;
    case '金融供应链实操系统':
      // 金融新实操系统
      host = getEnv('JRYWSCPT_WEB')
      params = {
        ...repeatParams,
        ...zljtParams,
        ...zljtParams2,
        nickname: Base64.encode(jumpParam.nickname),
        pattern: pattern,
      };
      break;
    default:
      break;
  }
  if(host==""){
    return
  }

  let dsParamStr = ""
  for (let key in params) {
    dsParamStr += (key + "=" + params[key] + "&")
  }
  let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
  let src = ""
  if(url){
    src = `${host}/#/${url}?${jumpStr}`
  }else{
    if(jumpParam.platform == 'PersonPictureOS'){
      src = `${host}/#/?${Base64.encode(jumpStr)}`
    }else{
      src = `${host}/#/?${jumpStr}`
    }
  }
  return src
}
// 区块链-供应链金融
async function blockjrkjJump(obj) {
  let iframeUrl = ''
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let catalogType = obj.catalogType || 'NONE'
  let teamId = 'NONE'
  let teamName = ''
  let { paramsList } = obj;
  let host = "";
  let arr = [];
  let templateCode = ""
  let roleCode = ""

  if (obj.myStation && obj.myStation[0]) {
    if (obj.myStation[0].teamId) {
      teamId = obj.myStation[0].teamId
    }
    teamName = obj.myStation[0].teamName
  }

  if (obj.productFlag === '1' || obj.productFlag === '2') { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag === '3' || obj.productFlag === '7') {  //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }

  if (paramsList.length > 0) {
    paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }
  let timestamp = obj.timestamp
  arr = [
    { key: "clientSecret", value: "qklc1d23491111ecab640c42a1e84123" },
    { key: "questionId", value: obj.listItem.id },
    { key: "sourceId", value: sourceId },
    { key: "timestamp", value: timestamp },
    { key: "token", value: obj.token },
  ];
  // sign加密
  let sign = ""; //加密串
  let sha1sign = ""
  arr.forEach((item) => {
    sign += `${item.key}=${item.value}&`;
  });
  sha1sign = setSha1(sign.substring(0, sign.length - 1));
  if(obj.platform == 'blockjrkjds'){
    host = getEnv('QKLGYLJRDS_API')
  }else{
    host = getEnv('QKLGYLJR_API')
  }
  let param = {
    clientId: "1349883712819109890",
    examPlan: obj.classId,
    examType: examType,
    mobile: obj.mobile,
    orgId: obj.deptId,
    paperCode: "",
    platform: obj.platform,
    questionId: obj.listItem.id,
    roleCode: roleCode,
    sign: sha1sign,
    sourceId: sourceId,
    teamId: teamId,
    teamName: teamName,
    timestamp: timestamp,
    token: obj.token,
    userCode: obj.userId,
    userName: obj.username,
    courseId: obj.courseId,
    classId: obj.classId,
  }

  if (host) {
    await axios.post(`${host}/eduToJrkjTeam`, param).then(res => {
      if (res.data.result) {
        if (param.platform == "blockjrkj"){
          iframeUrl = res.data.value + "&sourceId="+ param.sourceId +"_"+ param.questionId;
        }else {
          iframeUrl = res.data.value;
        }
      } else {
        Message({
          message: res.data.msg,
          type: 'error',
          showClose: true
        })
      }
    }).catch(err => {
      console.log(err)
    })
  } else {
    iframeUrl = ""
  }
  return {
    templateCode: templateCode,
    ...param, iframeUrl
  }
}
async function blockjrkjsxJump(obj) {
  let iframeUrl = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }

  let param = await zljtLoginParams(obj, 'szjr').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        sourceId: sourceId,
        encrypted: param.encrypted,
        token: res.data.data.access_token,
        pattern: 1,
        userId: obj.userId,
        questionId: obj.listItem.id,
      }

      let ParamStr = ""
      for (let key in params) {
        ParamStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = ParamStr.substring(0, ParamStr.length - 1)
      let src = `${ getEnv('QKLGYLJR_WEB') }/#/?${jumpStr}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}
// 新证券业务数字化
async function gxzxszzqJump(obj) {
  let iframeUrl = '';
  let templateCode = '';

  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
    })
  }

  let param = await zljtLoginParams(obj, 'szjr').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let host = ""
      let pattern = 1;
      let params = {}

      let token = res.data.data.access_token
      let zljtToken = token.substring(0, 36);

      // host = process.env.ZQYWSZH_WEB2
      host = getEnv('ZQYWSZH_WEB2')
      params = {
        token: zljtToken,
        questionId: obj.listItem.id,
        userId: obj.userId,
        sourceId: param.encrypted,
        nickname: Base64.encode(Base64.encode(obj.nickname)),
        product: Base64.encode(Base64.encode('实训证券业务数字化')),
        pattern: pattern,
        templateCode: templateCode,
        productIdEntity: "khhxDSJJR",
        roleIdentity: "ALL",
        sysIdentity: "SWSJFX"
      };

      let dsParamStr = ""
      for (let key in params) {
        dsParamStr += (key + "=" + params[key] + "&")
      }
      let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
      iframeUrl = `${host}/#/?${jumpStr}`
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}

// 柜台业务系统
async function gtywJump(obj) {
  let iframeUrl = '';
  let templateCode = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let roleCode = ""
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  let directedUrl = ""
  if (obj.listItem && obj.listItem.templates.length > 0) {
    obj.listItem.templates.forEach(v => {
      let arr = v.eventParam.split("&")
      arr.forEach(n => {
        if (n.split("=")[0] == "url") {
          directedUrl = n.split("=")[1]
        }
      })
    })
  }

  let clientSecret = '02424D4FD04A007E453DADA28E4EEE37';
  let md5sign = `clientSecret=${clientSecret}&questionId=${obj.listItem.id}&sourceId=${sourceId}&timestamp=${obj.timestamp}&token=${obj.token}`;
  let sign = MD5(md5sign)

  let param = await zljtLoginParams(obj, 'szjr').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        clientId: "1349883712819109890",
        orgId: obj.deptId,
        userCode: obj.userId,
        userId: obj.userId,
        keyId: obj.userId,
        userType: obj.userType,
        examType: examType,
        examPlan: '',
        paperCode: '',
        questionId: obj.listItem.id,
        item: "",
        courseId: obj.courseId,
        classId: obj.classId,
        teamId: obj.teamId,
        roleCode: roleCode,
        templateCode: templateCode,
        timestamp: obj.timestamp,
        token: obj.token,
        zljtToken: res.data.data.access_token,
        encrypted: param.encrypted,
        sourceId: sourceId,
        identity: "szjr",
        environment: "sx",
        platform: 'LobbyManagerOS',
        extend: '',
        sign: sign,
        directedUrl: directedUrl,
        nickname: Base64.encode(obj.nickname),
      }

      let ParamStr = ""
      for (let key in params) {
        ParamStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = ParamStr.substring(0, ParamStr.length - 1)
      let src = `${ getEnv('GTYW_WEB') }/#/?${Base64.encode(jumpStr)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}

// pc直播
async function pcliveJump(obj) {
  let menuCode = []
  if (obj.listItem && obj.listItem.templates.length > 0) {
    obj.listItem.templates.forEach(v => {
      let arr = v.eventParam.split("&")
      arr.forEach(n => {
        if (n.split("=")[0] == "menuCode") {
          menuCode.push(n.split("=")[1])
        }
      })
    })
  }

  let iframeUrl = ''

  // 获取所需参数
  let param =  await zljtLoginParams(obj, 'pclive').then(res =>{
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let dsParam = {
        token: res.data.data.access_token,
        gxzxToken: obj.token,
        userId: obj.userId,
        isTeamShare: 0,
        keyId: obj.teamId,
        roleCode: param.roleCode,
        templateCode: param.templateCode,
        sourceId: param.encrypted,
        menuCode: menuCode.length > 0 ? menuCode.join(',') : "",
        id: obj.listItem.id,
        nickname: Base64.encode(obj.nickname),
      }

      let dsParamStr = ""
      for (let key in dsParam) {
        dsParamStr += (key + "=" + dsParam[key] + "&")
      }

      let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
      let src = `${ getEnv('PC_LIVE_WEB') }/#/?${Base64.encode(jumpStr)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return { ...param, iframeUrl}
}

// zl大数据跳转
async function ZLBigDataOSJump(obj) {
  let iframeUrl = '';
  let templateCode = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let roleCode = "", urlCode = ""
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
      if (v.key === "urlCode") {
        urlCode = v.value
      }
    })
  }

  let param = await zljtLoginParams(obj, 'zlbi').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        sourceId: sourceId,
        templateCode: templateCode,
        zljtToken: res.data.data.access_token,
        sxToken: obj.token,
        userId: obj.userId,
        questionId: obj.listItem.id,
        platform: 'ZLBigDataOS',
        keyId: obj.userId,
        item: "",
        orgId: templateCode,
        nickname: obj.nickname,
        lang: 'zh-CN',
        userType: obj.userType,
        roleCodes: roleCode,
        examType: examType,
        tenant_path: urlCode,
        planMajor: sessionStorage.getItem('professional'),
        planId: obj.classId,
        courseId: obj.courseId,
        callBackUrl: `${ getEnv('BASE_API') }/api-user/sys/user/get`
      }
      if(examType === 15 ){
        params['extensionParam'] = obj.listItem.paperId;
        params['userId'] = obj.userId;
      }

      let ParamStr = ""
      for (let key in params) {
        ParamStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = ParamStr.substring(0, ParamStr.length - 1)
      let src = `${ getEnv('ZLBI_URL') }/#/home?${jumpStr}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}

// zl大数据2.0
async function zlbdJump(obj) {
  let menuCode = []
  if (obj.listItem && obj.listItem.templates.length > 0) {
    obj.listItem.templates.forEach(v => {
      let arr = v.eventParam.split("&")
      arr.forEach(n => {
        if (n.split("=")[0] == "menuCode") {
          menuCode.push(n.split("=")[1])
        }
      })
    })
  }

  let iframeUrl = '';
  let templateCode = '';
  let roleCode = ""

  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  let param = await zljtLoginParams(obj, 'zlbi').then(res => {
    return res
  })
  let app_api = `${getEnv('VUE_APP_VTAXTAPI')}/api-oauth/v1/oauth/v2/oauth/token`
  await axios.post(app_api, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        token: res.data.data.access_token,
        questionId: obj.listItem.id,
        keyId: obj.userId,
        sourceId: param.encrypted,
        sxToken: obj.token,
        templateCode: templateCode,
        roleCodes: roleCode,
        orgId: obj.deptId,
        orgName: obj.deptName,
        menuCode: menuCode.length > 0 ? menuCode.join(',') : "",
        nickname: Base64.encode(obj.nickname),
        userId: obj.userId,
        sex: obj.sex,
        prodName: Base64.encode(sessionStorage.getItem("prodName")),
        examType: examType,
        username: sessionStorage.getItem("userName"),
      }

      let ParamStr = ""
      for (let key in params) {
        ParamStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = ParamStr.substring(0, ParamStr.length - 1)
      let src = `${ getEnv('ZLBD_URL') }/#/login?${Base64.encode(jumpStr)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {iframeUrl, ...param}
}

// 大数据跳转
async function BigDataOSJump(obj) {
  let iframeUrl = ''
  let BigDataToken = ""
  let templateCode = ""
  let urlCode = ""
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "urlCode") {
        urlCode = v.value
      }
    })
  }
  let params = {
    "grant_type": "password",
    "username": obj.token,
    "password": obj.token,
    "matchPlanId": obj.classId,
    "planMajor": obj.productFlag,
    "orgId": templateCode, //公司ID 也就是账套信息 ： templateCode
    "tenant_path": urlCode, //以 / 拼接的层级关系 也就是： urlCode
    "callBackUrl": getEnv('BASE_API') + "/api-user/sys/user/get",
  }
  await axios({
    url: `${ getEnv('DSJ_API') }/connect/token`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      'Authorization': 'Basic aW50ZWdyYXRpb246ZXVuR0thczNQcWQ2Rk13eDllVXBkUzd4bXo=',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  }).then((rs) => {
    iframeUrl =  getEnv('DSJ_API') + '/integration/?token=' + rs.data.access_token;
    BigDataToken = rs.data.access_token;
  })
  return {...params, iframeUrl, BigDataToken}
}

// 绩效管理跳转
async function JiXiaoOSJump(obj) {
  let iframeUrl = ''

  // 获取所需参数
  let param = await zljtLoginParams(obj, 'jixiao').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let src = `${ getEnv('JIXIAO_API') }/#/login-sso?token=${res.data.data.access_token}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 新绩效管理-智慧金融
async function FinanceManageAccountJump(obj) {
  let iframeUrl = ''

  let param =  await zljtLoginParams(obj, 'FinanceManageAccount').then(res =>{
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let jumpStr = `token=${res.data.data.access_token}`;
      let src = `${ getEnv('JIXIAO2_WEB') }/#/login-sso?${jumpStr}`;
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return { ...param, iframeUrl}
}

// 审计数据跳转
async function sjsjJump(obj) {
  let iframeUrl = ''
  let {
    platform,
    listItem,
    deptId,
    deptName,
    mobile,
    userId,
    userType,
    token,
    item
  } = obj
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'
  let sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  // 获取所需参数
  let param = await zljtLoginParams(obj, platform).then(res => {
    return res
  })

  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let platforms = {
        managementAccount: 'GLKJ',
        SWFWYDSJYY: 'SWFWYDSJYY',
        NASHUIfinance: 'SWFWYDSJYY',
        QIYEZICHAfinance: 'SWFWYDSJYY',
        SHUIWUFENGXIANfinance: 'SWFWYDSJYY',
        ShuiFeiJiSuanfinance: 'SWFWYDSJYY',
        ExcelOS: 'ExcelOS',
        ExcelOS_Bak: 'ExcelOS',
        KeHuDataExcelOS: 'KeHuDataExcelOS',
        GongYShDataExcelOS: 'GongYShDataExcelOS'
      }
      let params = {
        sourceId: sourceId,
        lang: 'zh_CN',
        templateCode: param.templateCode,
        zljtToken: res.data.data.access_token,
        sxToken: token,
        userId: userId,
        questionId: listItem.id,
        platform: platform,
        sysId: platform,
        keyId: userId,
        item: item,
        orgId: deptId,
        nickname: Base64.encode(obj.nickname),
        userType: userType,
        identity: platform,
        roleCodes: param.roleCode
      }
      let str = ''
      Object.keys(params).map(v => {
        str += `${v}=${params[v]}&`
      })
      let jumpStr = str.substring(0, str.length - 1)
      iframeUrl = `${ getEnv('SJSJ_API') }/?${jumpStr}`
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 答题板跳转
async function ExcelOSJump(obj) {
  let iframeUrl = ''
  let {
    platform,
    listItem,
    deptId,
    deptName,
    mobile,
    userId
  } = obj

  // 获取所需参数
  let param = await zljtLoginParams(obj, platform).then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let platforms = {
        managementAccount: 'GLKJ',
        SWFWYDSJYY: 'SWFWYDSJYY',
        NASHUIfinance: 'SWFWYDSJYY',
        QIYEZICHAfinance: 'SWFWYDSJYY',
        SHUIWUFENGXIANfinance: 'SWFWYDSJYY',
        ShuiFeiJiSuanfinance: 'SWFWYDSJYY',
        ExcelOS: 'ExcelOS',
        ExcelOS_Bak: 'ExcelOS',
        KeHuDataExcelOS: 'KeHuDataExcelOS',
        GongYShDataExcelOS: 'GongYShDataExcelOS'
      }
      let glkjobj = {
        isHide: 0, //1开启、0关闭
        parentPlatform: platform.indexOf('managementAccount') != -1 ? 'managementAccount' : platform,
        token: res.data.data.access_token, //zljt的token
        userId: userId, //用户id
        questionId: listItem.id, //试题id
        platform: platform,
        sysId: platform.indexOf('managementAccount') != -1 ? platforms['managementAccount'] : platforms[platform],
        keyId: userId,
        templateCode: param.templateCode, //templateCode
        orgId: deptId, //机构id
        orgName: deptName, //机构名称
        encrypted: param.encrypted,
        mobile: mobile, //手机号
        identity: 'glkj', //子系统标识
        roleCodes: param.roleCode, //岗位
        ifTittleShow: param.ifTittleShow, //  是否展示excel表头（工具栏）
        ifSave: param.ifSave, // 是否显示 保存或审核 按钮
        applyScene: param.applyScene,  //  应用场景 （最初用于审计， 事项 Excel在审计中的应用 上有这个动态参数）
        parseType: param.saveStructure, // 新标准 和 旧标准 （excel 单元格 新 {}， 旧 sheet//col//row）
      }

      if(examType === 15){
        glkjobj['userCode'] = param.userId
        glkjobj['examType'] = examType
      }

      let str = ''
      Object.keys(glkjobj).map(v => {
        str += `${v}=${glkjobj[v]}&`
      })
      let jumpStr = str.substring(0, str.length - 1)
      iframeUrl = `${ getEnv('VUE_APP_ONLINEEXCEL') }/#/home?${jumpStr}`
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 管理会计跳转
async function glkjJump(obj) {
  let {
    platform,
    listItem,
    deptId,
    deptName,
    mobile,
    userId,
    paramsList
  } = obj;
  // 获取所需参数
  let param = await zljtLoginParams(obj, 'glkj').then(res => {
    return res
  })
  let iframeUrl = ''
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then((res) => {
    if (res.data.code == 0) {
      let platforms = {
        managementAccount: 'GLKJ',
        SWFWYDSJYY: 'SWFWYDSJYY',
        NASHUIfinance: 'SWFWYDSJYY',
        QIYEZICHAfinance: 'SWFWYDSJYY',
        SHUIWUFENGXIANfinance: 'SWFWYDSJYY',
        ShuiFeiJiSuanfinance: 'SWFWYDSJYY',
        ExcelOS: 'ExcelOS',
        KeHuDataExcelOS: 'KeHuDataExcelOS',
        GongYShDataExcelOS: 'GongYShDataExcelOS'
      }
      let glkjobj = {
        isHide: 0, //1开启、0关闭
        parentPlatform: platform.indexOf('managementAccount') != -1 ? 'managementAccount' : platform,
        token: res.data.data.access_token, //zljt的token
        userId: userId, //用户id
        questionId: listItem.id, //试题id
        platform: platform,
        sysId: platform.indexOf('managementAccount') != -1 ? platforms['managementAccount'] : platforms[platform],
        keyId: userId,
        templateCode: param.templateCode, //templateCode
        // id: 3000004888,
        // item: '8b001355-51ff-489c-a2b1-2f154ff787e3',//questionCode
        orgId: deptId, //机构id
        orgName: deptName, //机构名称
        encrypted: param.encrypted,
        // username: 'RC000124889',//登录名
        // password: '128810',//用户密码
        // nickname: '上官庆',//用户姓名
        // idCard: '110114199404128810',//证件号
        // headImgUrl: '',//头像
        // sex: '1',//性别
        // userType: '2',//用户类型
        mobile: mobile, //手机号
        identity: 'glkj', //子系统标识
        roleCodes: param.roleCode, //岗位
        // 2023.7.28 新加
        ifTittleShow: param.ifTittleShow, //  是否展示excel表头（工具栏）
        ifSave: param.ifSave, // 是否显示 保存或审核 按钮
        applyScene: param.applyScene,  //  应用场景 （最初用于审计， 事项 Excel在审计中的应用 上有这个动态参数）
        parseType: param.saveStructure, // 新标准 和 旧标准 （excel 单元格 新 {}， 旧 sheet//col//row）
      }
      if(examType === 15){
        glkjobj['userCode'] = param.userId
        glkjobj['examType'] = examType
      }
      /**
       *  管理会计1.0 版本控制
       *  wjl 2022.5.9
       *  产品 wdd
       */
      if (platform.includes('finance')) {
        paramsList.forEach(item => {
          if (item.key === 'ifSave') {
            glkjobj['ifSave'] = item.value || 100;
          } else if (item.key === 'financeVersion') {
            glkjobj['version'] = item.value;
          } else if (item.key === 'universal') {
            glkjobj['universal'] = item.value;
          }
        })
      }
      let str = ''
      Object.keys(glkjobj).map(v => {
        str += `${v}=${glkjobj[v]}&`
      })
      let jumpStr = str.substring(0, str.length - 1)
      let src = `${ getEnv('VUE_APP_ONLINEEXCEL') }/#/home?${jumpStr}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  })
  return {...param, iframeUrl}
}

// 智能文档
async function officeJump(obj) {
  let iframeUrl = '';

  let param = await zljtLoginParams(obj, 'wzxoffice').then(res => {
    return res
  })
  // await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    // if (res.data.code == 0) {
      let params = {
        // token: res.data.data.access_token,
        questionId: obj.listItem.id,
        sxToken: obj.token,
      }

      let ParamStr = ""
      for (let key in params) {
        ParamStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = ParamStr.substring(0, ParamStr.length - 1)
      let src = `${ getEnv('OFFICE_WEB') }/#/preview?${jumpStr}`

      iframeUrl = src
    // } else {
    //   Message({
    //     message: res.data.msg,
    //     type: 'error',
    //     showClose: true
    //   })
    // }
  // }).catch(err => {
  //   console.log(err)
  // })
  return {iframeUrl, ...param}
}

async function ECommerceProJump(obj){

  let iframeUrl = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }

  await axios.post(`${ getEnv('VUE_APP_LHRJ_API') }/api-sys/login/jxmobileGetdsToken`, {
    token: 'Bearer ' + obj.token,
    userId: obj.userId,
    mobile: obj.mobile,
    timestamp: obj.timestamp,
    sourceId,
  }).then(res => {
    if (res.data.code == 0) {

      let src = `${ getEnv('VUE_APP_DS_SELLER') }?seller_access_token=${res.data.data.access_token}&seller_refresh_token=${ res.data.data.refresh_token }&lhrj_access_token=${ res.data.data.lhrj_access_token }&platform=gxzx`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return { templateCode: '', iframeUrl }

}

/**
 *  仿真报税跳转
 *  王江龙  2022.5.27
 */
async function FZBSJump(obj) {
  let eventParamObj = {
    "kjsw_init": "",
    "lightInit": "",
  }
  if (obj.listItem && obj.listItem.templates.length > 0) {
    obj.listItem.templates.forEach(v => {
      let arr = v.eventParam.split("&")
      arr.forEach(n => {
        if (n.split("=")[0] == "kjsw_init") {
          eventParamObj["kjsw_init"] = n.split("=")[1]
        }
        if (n.split("=")[0] == "lightInit") {
          eventParamObj["lightInit"] = n.split("=")[1]
        }
      })
    })
  }

  // let {
  //   classId,
  //   deptId
  // } = obj;
  // let host = getEnv('FZBS_URL') ;
  //
  // let urlParam = {
  //   ...param,
  //   examPlan: classId,
  //   orgId: deptId,
  //   token: param.access_token,
  // }
  // iframeUrl = `${host}/?${qs.stringify(urlParam)}`


  let iframeUrl = ''
  let params = ''
  // 获取
  await getParams(obj).then(res => {

    // console.log('------res---', res)
    params = {
      /* 跳转参数 */
      // classId: "3025",
      clientId: res.clientId,
      // courseId: 1978,
      encrypted: res.encrypted,
      identity: res.identity,
      item: res.item,
      qstId: res.qstId,
      roleCode: res.roleCode,
      sign: res.sign,
      // teamId: "",
      // templateCode: "001",
      timeStamp: res.timeStamp,
      // token: "1ee217a7-47ae-47f8-b519-5410a1909f1d",
      userId: res.userId,
      userType: res.userType,
      username: res.username,

      /* 埋点参数 */
      userCode: res.userId, //	用户唯一ID（与传入的参数userCode对应）
      examType: examType, //	类型（与传入的参数examType对应）
      examPlan: res.classId, //	考试计划（与传入的参数examPlan对应）
      paperCode: '', //	试卷id（与传入的参数paperCode对应）
      questionCode: res.qstId, //	试题id（与传入的参数questionId对应）
      courseId: res.courseId, //	课程id（与传入的参数对应）
      classId: res.classId, //	班级id（与传入的参数对应）
      // formName: '', //	事项编码（不为null,为埋点事项字段，单独对接）
      // formMapper: '', //	事项明细（可为null，根据产品设计,为埋点事项字段，单独对接）
      // detailContent: '', //	学生答案（不为null，当signStatus为删除态时可为null）
      templateCode: res.templateCode, //	账套模板编码：(有则传，具体视业务情况)
      signStatus: 0, //	0-插入insert 1-删除作废
      businessCode: '', //	业务的唯一id
      roles: res.roleCode, //	角色，（与传入的参数roleCode对应）
      teamId: res.teamId, //	小组id（综合实训模式不为null）
      remarkCode: '', //	批量删除标识位（提供给有批量删除埋点需求的业务使用，要保证使用的值是唯一的，如uuid，如：区块链场景下：BlockChainOS-md5(sourceId)）
      environment: '', //	保留字段，埋点接口直接回填即可
      platform: res.platform, //	保留字段，埋点接口直接回填即可
      extend: '', //	保留字段，埋点接口直接回填即可
      orgId: res.deptId,
      token: res.token,
      access_token: res.access_token,
      ...eventParamObj,
    }
    let host = getEnv('FZBS_URL') ;
    iframeUrl = `${host}/?${qs.stringify(params)}`

  })

  return {...params, iframeUrl}
}

// (税务仿真平台)  自然人电子税务局（扣缴端） 跳转
// wjl 2022.5.9
async function ZRRDZSWJJump(obj) {
  let iframeUrl = '';

  let param = await zljtLoginParams(obj, 'ChinaGovTaxApply').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let src = `${ getEnv('ZRR_DZSWJ_API') }/#login?token=${res.data.data.access_token}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })

  return {...param, iframeUrl}

}
// 个税跳转2.0
// zjf 2023.7.12
async function ZRRDZSWJ2Jump(obj) {
  let eventParamObj = {
    "lightInit": "",
    "module": "",
  }
  if (obj.listItem && obj.listItem.templates.length > 0) {
    obj.listItem.templates.forEach(v => {
      let arr = v.eventParam.split("&")
      arr.forEach(n => {
        if (n.split("=")[0] == "lightInit") {
          eventParamObj["lightInit"] = n.split("=")[1]
        }
        if (n.split("=")[0] == "module") {
          eventParamObj["module"] = n.split("=")[1]
        }
      })
    })
  }
  let iframeUrl = '';
  let param = await zljtLoginParams(obj, 'ChinaGovTaxApply2.0').then(res => {
    return res
  })
  await axios.post(`${ getEnv('VUE_APP_VTAXTAPI') }/api-oauth/v1/oauth/v2/oauth/token`, {
    ...param,
    ...eventParamObj
  }).then(res => {
    if (res.data.code == 0) {
      let src = `${ getEnv('ZRR_DZSWJ_API2') }/#login?token=${res.data.data.access_token}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 区块链
async function qklJump(obj) {
  let iframeUrl = '';
  let templateCode = '';
  let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_${实训还是课程（catalogType）}
  let roleCode = ""
  let catalogType = obj.catalogType || 'NONE'
  let teamId = (obj.myStation && obj.myStation[0]) ? obj.myStation[0].teamId ? obj.myStation[0].teamId : 'NONE' : 'NONE'

  if (obj.productFlag == 1 || obj.productFlag == 2) { //单项
    sourceId = `4_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) { //综合
    sourceId = `3_${obj.courseId}_${obj.classId}_NONE_${teamId}_${obj.userId}_${catalogType}`
  }
  if (obj.paramsList.length > 0) {
    obj.paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  let clientSecret = 'qklc1d23491111ecab640c42a1e84123';
  let md5sign = `clientSecret=${clientSecret}&questionId=${obj.listItem.id}&sourceId=${sourceId}&timestamp=${obj.timestamp}&token=${obj.token}`;
  let sign = MD5(md5sign)
  let params = {
    clientId: obj.clientId,
    orgId: obj.deptId,
    userCode: obj.userId,
    examType: examType,
    examPlan: '',
    paperCode: '',
    questionId: obj.listItem.id,
    courseId: obj.courseId,
    classId: obj.classId,
    teamId: obj.teamId,
    roleCode: roleCode,
    timestamp: obj.timestamp,
    token: obj.token,
    sourceId: sourceId,
    environment: "sx",
    platform: 'BlockChainOS',
    extend: '',
    sign: sign,
    templateCode: templateCode,
  }

  await axios({
    url: `${ getEnv('VUE_APP_QKL') }/mgr/WeBASE-Node-Manager/biz/login`,
    method: "post",
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then((res) => {
    if (res.data.code === 0) {
      if (res.data.data) {
        iframeUrl = res.data.data.url + '?token=' + res.data.data.token
      }
    } else {
      Message({
        message: '区块链: ' + res.data.message,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...params, iframeUrl}
}

/**
 *   wjl  代码填空跳转  2022.7.18
 *   @returns { iframeUrl:'url' }
 */
async function codeFangZhenPageJump(obj) {
  let iframeUrl = '';
  let sourceId = "";
  let params = "";
  if (obj.productFlag == 1 || obj.productFlag == 2) {   //单项
    sourceId = `TEACH_${obj.courseId}_${obj.classId}_1_NONE`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) {   //综合
    sourceId = `TEACH_${obj.courseId}_${obj.classId}_2_NONE`
  }

  let param = await zljtLoginParams(obj, obj.platform).then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {

      params = {
        sourceId: sourceId,
        templateCode: param.templateCode,
        zljtToken: res.data.data.access_token,
        sxToken: param.token,
        nickname: param.nickname,
        userId: param.userId,
        platform: obj.platform,
        sysId: obj.platform,
        keyId: param.teamId || param.userId,
        item: param.item,
        orgId: obj.deptId,
        userType: param.userType,
        identity: param.identity,
        roleCodes: param.roleCode,
        questionId: param.qstId,
        examType: examType,
      }

      let src = `${ getEnv('VUE_APP_CODE') }/?${qs.stringify(params)}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })

  return {...params, iframeUrl}
}

// rpa跳转
async function rpaJump(obj) {
  let {
    token,
    userId,
    resourceId,
    courseId,
    classId,
    platform,
    teamId,
    paramsList
  } = obj

  if(obj.listItem && obj.listItem.model === 'cy'){  // 考试 分两种
    if(Number(obj.productFlag) === 1){  // 课政融通
      examType = 15   // 课政融通测评
    }else{
      examType = 5  // 测验考试
    }
  }else if(Number(obj.productFlag) === 1 || Number(obj.productFlag) === 2){  // 课政融通
    examType = 4
  }else if(Number(obj.productFlag) === 3 || Number(obj.productFlag) === 7){  //综合实训
    examType = 3
  }

  let templateCode = ""
  let roleCode = ""
  if (paramsList.length > 0) {
    paramsList.forEach(v => {
      if (v.key === "templateCode") {
        templateCode = v.value
      }
      if (v.key === "roles") {
        roleCode = v.value
      }
    })
  }

  let params = {
    "tokenType": "bearer",
    "accessToken": token,
    "userCode": userId,
    "examPlan": "",
    "paperCode": "",
    "qstId": resourceId,
    "questionCode": resourceId,
    "courseId": courseId,
    "classId": classId,
    "templateCode": templateCode,
    "roles": roleCode,
    "callbackUrl": getEnv('BASE_API'),
    "domain": getEnv('BASE_API'),
    "environment": "sx",
    "platform": platform,
    "extend": "",
    "examType": examType,
    "teamId": teamId ? teamId : "",
  }

  // console.log(params)
  // window.location = "https://zledu-static.oss-cn-beijing.aliyuncs.com/tools/Encoo.Studio.Setup.exe";

  let data = {
    iframeUrl: 'Encoo.Studio://' + Base64.encode(JSON.stringify(params)),
    downloadUrl: "https://zledu-static.oss-cn-beijing.aliyuncs.com/tools/study/Encoo.Studio.Setup.exe",
    ...params
  }
  return data
}

// 大数据埋点 步骤1
function BigDataBuriedPoint(obj) {
  let param = {
    url: "https://bi.cailian.net/api/graphql?token=" + obj.BigDataToken,
    method: "POST",
    headers: {
      "Reference-Token": obj.BigDataToken,
    },
    data: {
      "query": "query {documents(types: \"dataset\" lng: \"zh\", orderby: \"+name\", limit: 101, offset: 0) { id, title}}"
    },
  };
  axios.request(param)
    .then((res) => {
      if (res.status == 200 && res.data.data && res.data.data.documents && res.data.data.documents.length) {
        let promiseAll = [];
        [].forEach.call(res.data.data.documents, item => {
          promiseAll.push(bigDataPoint2(item.id, obj))
        })
        Promise.all(promiseAll).then(res => {
          bigDataPoint3(res, obj);
        })
      }
    }).catch(() => {
  });
}

// 大数据埋点 步骤2
function bigDataPoint2(id, obj) {
  let param = {
    url: "https://bi.cailian.net/api/datasetmanagement/download/" + id + "?token=" + obj.BigDataToken,
    method: "GET",
    headers: {
      "Reference-Token": obj.BigDataToken,
    }
  };
  return axios.request(param)
    .then((res) => {
      if (res.status == 200) {
        res.data.businessCode = id
        return Promise.resolve(res.data);
      }
    }).catch(() => {
    });
}

// 大数据埋点 步骤3
function bigDataPoint3(res, obj) {
  let BigData = JSON.parse(JSON.stringify(res));
  [].forEach.call(BigData, item => {
    let params = {
      businessCode: item.businessCode,
      "formName": "makeCollectionForm",
      "detailContent": {
        "collectionTableName": "",
        "dataSource": [],
        "Fields": [],
        "GroupFields": [],
        "FilterConditions": []
      },
      "formMapper": {
        "collectionTableName": ""
      }
    };
    if (item.Name) {
      params.detailContent.collectionTableName = item.Name;
      params.formMapper.collectionTableName = item.Name;
    }
    if (item.Query && item.Query.DataSources && item.Query.DataSources.length) {
      let DataSources = [];
      [].forEach.call(item.Query.DataSources, w => {
        DataSources.push({
          "tableName": w.Name,
        })
      })
      params.detailContent.dataSource = DataSources;
    }
    if (item.Fields && item.Fields.length) {
      let Fields = [];
      [].forEach.call(item.Fields, w => {
        Fields.push({
          "name": w.Name,
          "tableName": w.TableName,
          "Aggregation": w.Aggregation,
        })
      })
      params.detailContent.Fields = Fields;
    }
    if (item.GroupFields && item.GroupFields.length) {
      let GroupFields = [];
      [].forEach.call(item.GroupFields, w => {
        GroupFields.push({
          "DataField": w.DataField,
          "TableName": w.TableName,
        })
      })
      params.detailContent.GroupFields = GroupFields;
    }
    if (item.FilterConditions && item.FilterConditions.ConditionItems && item.FilterConditions.ConditionItems.length) {
      let FilterConditions = [];
      [].forEach.call(item.FilterConditions.ConditionItems, w => {
        FilterConditions.push({
          "Column": w.Column,
          "Operator": w.Operator,
          "param": w.param,
        })
      })
      params.detailContent.FilterConditions = FilterConditions;
    }
    postBigDataPoint(params, obj);
  })
}

// 大数据埋点 步骤4
function postBigDataPoint(params, obj) {
  let encrypted = "";
  let teamId = ""

  async function getData() {
    let paramsList = obj.courseId;
    let roleCode = ""
    let templateCode = ""
    if (paramsList.length > 0) {
      paramsList.forEach(v => {
        if (v.key == "templateCode") {
          templateCode = v.value
        }
        if (v.key == "roles") {
          roleCode = v.value
        }
      })
    }
    if (obj.productFlag == 1 || obj.productFlag == 2) {
      teamId = ""
      encrypted = `TEACH_${obj.courseId}_${obj.classId}_1_NONE`
    } else if (obj.productFlag == 3 || obj.productFlag == 7) {
      teamId = obj.myStation.length ? obj.myStation[0].teamId : ""
      encrypted = `TEACH_${obj.courseId}_${obj.classId}_2_${teamId}`
    }

    let bigData = {
      "recordBuryPoint": {
        detailContent: JSON.stringify(params.detailContent),
        formName: params.formName, // 事项formName
        formMapper: JSON.stringify(params.formMapper), // 事项formMapper
        userCode: obj.userId, // 考生本次考试唯一ID编号
        examType: examType,
        examPlan: '', // 考试计划
        paperCode: '', // 试卷id
        questionCode: obj.listItem.id, // 试题id
        courseId: obj.courseId, // 课程id
        classId: obj.classId, // 班级ID
        templateCode: templateCode, //  账套模板编码
        signStatus: 0, //  0-插入insert 1-删除作废
        remarkCode: '', //  备用字段
        teamId: teamId, //  小组id
        roles: roleCode, //  角色岗位
        businessCode: params.businessCode, //  确定唯一一个表单的id，与formName+formMapper一一对应.
      },
      "platform": obj.platform,
      // "platform": 'managementAccount',  // 默认走管理会计的埋点库
      "encrypted": encrypted,
    };
    let param = {
      url: `/api-studylog/noAuth/common/save`,
      method: "POST",
      data: bigData
    };
    axios.request(param).then((res) => {
      if (res.code == 0) {
        console.log('--bigData数据埋点--', res.data)
      }
    }).catch(() => {
    });
  }

  getData()
}

/**
 *   sq  真实任务审计跳转  2022.11.11
 *   @returns { iframeUrl:'url' }
 */
async function zsrwsjJump(obj) {
  let returnParms = {
    iframeUrl: "",
  }

  let signObj = {
    clientId: obj.clientId,
    encrypted: obj.encrypted,
    identity: obj.identity,
    item: obj.item,
    qstId: obj.listItem.id,
    roleCode: obj.roleCode,
    templateCode: obj.templateCode,
    timeStamp: obj.timeStamp,
    token: obj.token,
    userType: obj.userType,
    username: obj.username,
  }
  // sign加密
  let signString = ""; //加密串

  for (const key in signObj) {
    signString += `${key}=${signObj[key]}, `;
  }
  let signJson = `{${signString.substring(0, signString.length - 2)}}`
  let sign = setSha1(signJson, '02424D4FD04A007E453DADA28E4EEE37')

  //请求传的参数
  let param = {
    clientId: obj.clientId,
    encrypted: obj.encrypted,
    identity: obj.identity,
    item: obj.item,
    qstId: obj.listItem.id,
    roleCode: obj.roleCode,
    sign,
    templateCode: obj.templateCode,
    timeStamp: obj.timeStamp,
    token: obj.token,
    userType: obj.userType,
    username: obj.username,
  };
  if(examType === 15){
    param['userCode'] = obj.userId
  }

  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let jumpStr = `productFlag=4&token=${res.data.data.access_token}&gxzxToken=${obj.token}`
      let src = `${getEnv('XSJ_API')}?${Base64.encode(jumpStr)}`
      returnParms.iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return returnParms
}

/**
 *   sq  真实任务估值跳转  2022.12.19
 *   @returns { iframeUrl:'url' }
 */
async function zsrwgzJump(obj) {
  let returnParms = {
    iframeUrl: "",
  }

  if(obj.listItem && obj.listItem.model === 'cy'){  // 考试 分两种
    if(Number(obj.productFlag) === 1){  // 课政融通
      examType = 15   // 课政融通测评
    }else{
      examType = 5  // 测验考试
    }
  }else if(Number(obj.productFlag) === 1 || Number(obj.productFlag) === 2){  // 课政融通
    examType = 4
  }else if(Number(obj.productFlag) === 3 || Number(obj.productFlag) === 7){  //综合实训
    examType = 3
  }

  // sign加密
  let url = 'classId=' + obj.classId + '&className=' + obj.className + '&courseId=&courseName=&examType=' + examType + '&mobile=' +
    obj.phone + '&model=zsrw&nickName=' + obj.nickName + '&platform=&questionId=&roles=&schoolId=&schoolName=&teamId=&teamName=&templateCode=&time=' + obj.time + '&userId=' +
    obj.userId + '&userType=' + obj.userType
  let sign = setSha1(url)

  //请求传的参数
  let param = {
    classId: obj.classId,
    className: obj.className,
    courseId: obj.courseId,
    courseName: obj.courseName,
    examType: examType,
    mobile: obj.mobile,
    model: obj.model,
    nickName: obj.nickName,
    platform: obj.platform,
    schoolId: obj.schoolId,
    schoolName: obj.schoolName,
    templateCode: obj.templateCode,
    time: obj.time,
    userId: obj.userId,
    questionId: obj.questionId,
    roles: obj.roles,
    teamId: obj.teamId,
    teamName: obj.teamName,
    userType: obj.userType,
    sign: sign
  };

  axios.post( getEnv('MGYZSRW_API'), qs.stringify(param)).then(res => {
    if (res.data.result) {
      let src = res.data.value
      returnParms.iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return returnParms
}

async function sqlDataOSJump(obj) {
  let iframeUrl = '';
  let sourceId = "";
  let params = "";
  if (obj.productFlag == 1 || obj.productFlag == 2) {   //单项
    sourceId = `TEACH_${obj.courseId}_${obj.classId}_1_NONE`
  } else if (obj.productFlag == 3 || obj.productFlag == 7) {   //综合
    sourceId = `TEACH_${obj.courseId}_${obj.classId}_2_NONE`
  }

  let param = await zljtLoginParams(obj, obj.platform).then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let iframeParam = {
        sourceId: sourceId,
        zljtToken: res.data.data.access_token,
        sxToken: param.token,
        userId: param.userId,
        questionId: param.qstId,
        platform: obj.platform,
        sysId: obj.platform,
        keyId: param.teamId || param.userId,
        templateCode: param.templateCode,
        item: param.item,
        orgId: obj.deptId,
        nickname: param.nickname,
        userType: param.userType,
        identity: param.identity,
        lang: "zh_CN",
        // pattern: this.matchType,
        // matchPlanId: this.planId,
        // playerId: this.matchPlayerId,
        stationId: "",
        isLeader: "",
        // paperCode: this.paperCode,
        questionCode: param.item,
        examType: examType,  // 2考试  3综合  4单项  5测验  6大赛  15课证融通测评
        // from: "resource",  // 编辑和查看
      };

      iframeUrl = `${process.env.VUE_APP_CODE}?${qs.stringify(
        iframeParam
      )}`;
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })

  return {...params, iframeUrl}
}

// 物流vr
async function wuliuJump(obj) {
  let iframeUrl = ''
  // 获取所需参数
  let param = await zljtLoginParams(obj, 'wuliu').then(res => {
    return res
  })
  await axios.post(`${ getEnv('ZLJT_API') }/api-oauth/v1/oauth/v2/oauth/token`, param).then(res => {
    if (res.data.code == 0) {
      let params = {
        sourceId: param.encrypted,
        lang: "zh_CN",
        templateCode: param.templateCode,
        zljtToken: res.data.data.access_token,
        sxToken: param.token,
        userId: obj.userId,
        questionId: obj.listItem.id,
        platform: obj.platform,
        sysId: obj.platform,
        keyId: param.teamId || param.userId,
        item: param.item,
        orgId: obj.deptId,
        nickname:obj.nickname,
        examType: examType,
        userType: param.userType,
        identity:  obj.platform,
        codeLang: "C",
        roleCodes: param.roleCode,
        // buryType=undefined
      }

      let paramStr = ""
      for (let key in params) {
        paramStr += (key + "=" + params[key] + "&")
      }

      let jumpStr = paramStr.substring(0, paramStr.length - 1)
      let src = `${ getEnv('VUE_APP_CODE') }/?${jumpStr}`
      iframeUrl = src
    } else {
      Message({
        message: res.data.msg,
        type: 'error',
        showClose: true
      })
    }
  }).catch(err => {
    console.log(err)
  })
  return {...param, iframeUrl}
}

// 加密
function setSha1(url, secretKey) {
  let hmac = crypto.createHmac('sha1', secretKey || '123456');
  hmac.update(url);
  return hmac.digest('hex');
}

// 参数排序
function sortNum(prop) {
  return function (a, b) {
    let value1 = a[prop];
    let value2 = b[prop];
    return value1.localeCompare(value2)
  }
}

/* 本地部署，从本地配置文件中获取地址 */
function getEnv(key) {
  if (process.env.NODE_ENV === 'native' && window.g){
    return window.g[key];
  }else{
    return process.env[key];
  }
}

export default {
  plateformJump,
  rpaJump,
  BigDataBuriedPoint,
  zsrwsjJump,
  zsrwgzJump
}



// WEBPACK FOOTER //
// ./src/utils/platformJump.js